import client from "../utils/client";
import { apiBaseUrl } from '../constants/configuration';
import { endPoints, authEndPoints } from "../constants/configuration";
import { add } from "lodash";
import { Tab } from "semantic-ui-react";


// Age Graph API

export const postAgeGraphReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  id = 'all'
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/age-performance?list=${id}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// Gender Graph API function

export const postGenderGraphReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  id = 'all'
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/gender-performance?list=${id}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// ion
export const getNewSegmentListApi = async ({ tenantId, authToken, userId, customerId, hierarchyVar, parentVar, grandVar, type }) => {
  let a = '';
  if (type == 'segment') {
    a = `${hierarchyVar}&parent=${parentVar}`;
    if (grandVar != '') {
      a = `${hierarchyVar}&parent=${parentVar}&grand=${grandVar}`;
    }
  } else {
    a = hierarchyVar;
  }
  try {
    const { data } = await client().get(`ion-atd/audience?list=part&hierarchy=${a}&customer=${customerId}`, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_user': userId,
          'tai_token': `${authToken}`
        }
      }
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

// all the apis can be called from here

// export const getConfigurationData = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/config?action=list&type=all', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getFilterListApi = async ({ tenantId, authToken, userId }) => {
  // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
  // const authData = JSON.parse(localStorage.getItem('AuthData'));
  try {
    const { data } = await client().get(endPoints.ionReport + "/list/custom", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIonFilterListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.ionReport + "/list/ion/custom",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// export const getPreSignInData = async (preSignInReqBody) => {
//   try {
//     const { data } = await client({ auth: true }).post(
//       endPoints.auth + "/oauth/pre-signin",
//       preSignInReqBody
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };

export const getPreSignInData = async preSignInReqBody => {
  try {
    const { data } = await client().post(
      endPoints.auth + `/oauth/v2/pre-signin?data=${preSignInReqBody}`,
      {}
    );
    return data;
  } catch (error) {
  }
}


export const postSignupApi = async (payload) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/self-register/submit",
      payload
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const getSignInData = async (signInReqBody) => {
//   try {
//     const { data } = await client({ auth: true }).post(
//       endPoints.auth + "/oauth/signin",
//       signInReqBody
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };

// export const getReSignInData = async ({ reSignInReqBody, authToken }) => {
//   try {
//     const { data } = await client({ auth: true }).post(
//       endPoints.auth + "/oauth/re-signin",
//       reSignInReqBody,
//       {
//         headers: {
//           common: {
//             Authorization: `Bearer ${authToken}`,
//           },
//         },
//       }
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };

export const getSignInData = async signInReqBody => {
  try {
    const { data } = await client().post(
      endPoints.auth + '/oauth/v2/signin',
      {},
      {
        params: { data: signInReqBody }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getReSignInData = async ({ reSignInReqBody, authToken }) => {
  try {
    const { data } = await client().post(
      endPoints.auth + '/oauth/v2/re-signin',
      {},
      {
        params: { data: reSignInReqBody },
        headers: {
          common: {
            'Authorization': `Bearer ${authToken}`,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const logoutApi = async ({ logoutReqBody, authToken }) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/oauth/logout",
      logoutReqBody,
      {
        headers: {
          common: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---* ION * ---

// * adUnitApi *
export const getAdUnitListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.adunit + "?listaddunit=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editAdUnitApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.adunit, {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAdUnitApi = async ({
  tenantId,
  authToken,
  userId,
  adUnitReqBody,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.adunit, adUnitReqBody, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteAdUnitApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.adunit, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// * AdUnit Group Api *
export const addAdUnitGroupApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.adgroup, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdUnitGroupListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.adgroup + "?listadgroup=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteAdUnitGroupApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.adgroup, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

//  * Private Market Place *
export const getPMPListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.pmp + "?listpmp=auto", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRoadblockListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.pmp + "?listpmp=roadblock", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addRoadblock = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.pmp, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addPMPApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.pmp, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deletePMPApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.pmp, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// Add Mediation AdGroup

export const getMediationAdGroupListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.mediation + "?listadgroup=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addMediationAdGroupListApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.mediation, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteMediationAdGroupApi = async ({
  tenantId,
  authToken,
  userId,
  addParams,
}) => {
  try {
    const { data } = await client().get(endPoints.mediation, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// mediation  api

export const getMediationApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.mediation + "?listmediationt=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addMediationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.mediation, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteMediationApi = async ({
  tenantId,
  authToken,
  userId,
  addParams,
}) => {
  try {
    const { data } = await client().get(endPoints.mediation, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// * Tagld Mapping *
export const getTagldMappingListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.adUnitMap + "?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// *****************ATD  DASHBOARD API *******************************

// getListAdvertiserApi

export const getListAdvertiserApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.atdDashboard + "/custom", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdvertiserWithoutAccApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    // const { data } = await client().get(endPoints.atd + "/advertiser?action=advertisers_without_accounts", {
    // const { data } = await client().get(endPoints + `/report-atd/advertiser?action=advertisers_without_accounts", {
    const { data } = await client().get(endPoints.atdDashboard + "/advertiser?action=advertisers_without_accounts", {

      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// creativeApiDetails
export const creativeDetailsApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=${campaignId}&datewise=0`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const domainReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId,
  params, Addparams
}) => {
  try {
    // console.log("action", campaignId);
    // console.log("params", params);
    const { data } = await client().post(
      endPoints.atdDashboard + `/domain-performance?list=${campaignId}&offset=${params.pn}&limit=${params.rc}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};





export const demoGraphicReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/age-gender-performance?campaignId=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const deviceReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/device-performance?list=${campaignId}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const deviceReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/device-performance?list=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};







export const campaignPerformanceReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/campaign-performance?action=list",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const campaignPerformanceTotalReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/campaign-performance?list=total",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    // let data = {"responseCode":{"msg":"List Fetched Successfully","status":"Success","code":4002},"responseList":[{"platformId":0,"impressions":62486464,"clicks":703479,"conversions":37441,"spend":5130422.0,"cr":5.3223,"ctr":1.1258,"ecpm":82.10453,"cpa":137.02684,"cpc":7.292928,"start_video":62486464,"first_quartile":1961590.0,"second_quartile":1709643.0,"third_quartile":1547511.0,"complete_view":1429124.0,"vcr":190.9972}],"length":0}
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const campaignPerformanceReportDatewiseApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=total&datewise=1`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    // let data =
    // {
    //   "responseCode": {
    //     "msg": "List Fetched Successfully",
    //     "status": "Success",
    //     "code": 4002
    //   },
    //   "responseList": [
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-01",
    //       "impressions": 400290,
    //       "clicks": 7945,
    //       "conversions": 280,
    //       "spend": 59201.13,
    //       "cr": 3.5242,
    //       "ctr": 1.9848,
    //       "ecpm": 147.8956,
    //       "cpa": 211.4326,
    //       "cpc": 7.4513693,
    //       "start_video": 400290,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-02",
    //       "impressions": 438852,
    //       "clicks": 9287,
    //       "conversions": 446,
    //       "spend": 86018.8,
    //       "cr": 4.8024,
    //       "ctr": 2.1162,
    //       "ecpm": 196.00868,
    //       "cpa": 192.86726,
    //       "cpc": 9.26228,
    //       "start_video": 438852,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-03",
    //       "impressions": 374380,
    //       "clicks": 7807,
    //       "conversions": 461,
    //       "spend": 76359.375,
    //       "cr": 5.905,
    //       "ctr": 2.0853,
    //       "ecpm": 203.96223,
    //       "cpa": 165.63857,
    //       "cpc": 9.780887,
    //       "start_video": 374380,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-04",
    //       "impressions": 406256,
    //       "clicks": 7744,
    //       "conversions": 391,
    //       "spend": 77079.85,
    //       "cr": 5.0491,
    //       "ctr": 1.9062,
    //       "ecpm": 189.73221,
    //       "cpa": 197.13516,
    //       "cpc": 9.953493,
    //       "start_video": 406256,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-05",
    //       "impressions": 355945,
    //       "clicks": 7179,
    //       "conversions": 391,
    //       "spend": 66963.82,
    //       "cr": 5.4464,
    //       "ctr": 2.0169,
    //       "ecpm": 188.12968,
    //       "cpa": 171.26297,
    //       "cpc": 9.327737,
    //       "start_video": 355945,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-06",
    //       "impressions": 434478,
    //       "clicks": 8405,
    //       "conversions": 480,
    //       "spend": 66846.22,
    //       "cr": 5.7109,
    //       "ctr": 1.9345,
    //       "ecpm": 153.8541,
    //       "cpa": 139.26295,
    //       "cpc": 7.9531493,
    //       "start_video": 434478,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-07",
    //       "impressions": 452002,
    //       "clicks": 8701,
    //       "conversions": 479,
    //       "spend": 66843.69,
    //       "cr": 5.5051,
    //       "ctr": 1.925,
    //       "ecpm": 147.88362,
    //       "cpa": 139.54842,
    //       "cpc": 7.6822996,
    //       "start_video": 452002,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-08",
    //       "impressions": 426355,
    //       "clicks": 8551,
    //       "conversions": 491,
    //       "spend": 76558.65,
    //       "cr": 5.742,
    //       "ctr": 2.0056,
    //       "ecpm": 179.5655,
    //       "cpa": 155.92393,
    //       "cpc": 8.953181,
    //       "start_video": 426355,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-09",
    //       "impressions": 366117,
    //       "clicks": 7433,
    //       "conversions": 376,
    //       "spend": 61716.61,
    //       "cr": 5.0585,
    //       "ctr": 2.0302,
    //       "ecpm": 168.57072,
    //       "cpa": 164.13992,
    //       "cpc": 8.303056,
    //       "start_video": 366117,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-10",
    //       "impressions": 343757,
    //       "clicks": 6782,
    //       "conversions": 332,
    //       "spend": 72138.56,
    //       "cr": 4.8953,
    //       "ctr": 1.9729,
    //       "ecpm": 209.85336,
    //       "cpa": 217.28482,
    //       "cpc": 10.636768,
    //       "start_video": 343757,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-11",
    //       "impressions": 324903,
    //       "clicks": 6623,
    //       "conversions": 302,
    //       "spend": 71575.1,
    //       "cr": 4.5599,
    //       "ctr": 2.0385,
    //       "ecpm": 220.29683,
    //       "cpa": 237.00365,
    //       "cpc": 10.807051,
    //       "start_video": 324903,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-12",
    //       "impressions": 406449,
    //       "clicks": 8408,
    //       "conversions": 260,
    //       "spend": 69224.9,
    //       "cr": 3.0923,
    //       "ctr": 2.0686,
    //       "ecpm": 170.31633,
    //       "cpa": 266.2496,
    //       "cpc": 8.233218,
    //       "start_video": 406449,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-13",
    //       "impressions": 333747,
    //       "clicks": 7774,
    //       "conversions": 330,
    //       "spend": 55779.82,
    //       "cr": 4.2449,
    //       "ctr": 2.3293,
    //       "ecpm": 167.13205,
    //       "cpa": 169.02975,
    //       "cpc": 7.175176,
    //       "start_video": 333747,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-14",
    //       "impressions": 362900,
    //       "clicks": 7058,
    //       "conversions": 324,
    //       "spend": 52827.312,
    //       "cr": 4.5905,
    //       "ctr": 1.9449,
    //       "ecpm": 145.56989,
    //       "cpa": 163.04726,
    //       "cpc": 7.484742,
    //       "start_video": 362900,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-15",
    //       "impressions": 379431,
    //       "clicks": 7911,
    //       "conversions": 448,
    //       "spend": 69307.82,
    //       "cr": 5.663,
    //       "ctr": 2.085,
    //       "ecpm": 182.66252,
    //       "cpa": 154.70496,
    //       "cpc": 8.760943,
    //       "start_video": 379431,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-16",
    //       "impressions": 344017,
    //       "clicks": 7326,
    //       "conversions": 287,
    //       "spend": 67690.38,
    //       "cr": 3.9176,
    //       "ctr": 2.1295,
    //       "ecpm": 196.76463,
    //       "cpa": 235.85498,
    //       "cpc": 9.239746,
    //       "start_video": 344017,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-17",
    //       "impressions": 276670,
    //       "clicks": 7269,
    //       "conversions": 366,
    //       "spend": 57659.62,
    //       "cr": 5.0351,
    //       "ctr": 2.6273,
    //       "ecpm": 208.40575,
    //       "cpa": 157.53995,
    //       "cpc": 7.932263,
    //       "start_video": 276670,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-18",
    //       "impressions": 278374,
    //       "clicks": 6796,
    //       "conversions": 250,
    //       "spend": 57210.34,
    //       "cr": 3.6786,
    //       "ctr": 2.4413,
    //       "ecpm": 205.51611,
    //       "cpa": 228.84137,
    //       "cpc": 8.418238,
    //       "start_video": 278374,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-19",
    //       "impressions": 325421,
    //       "clicks": 9294,
    //       "conversions": 475,
    //       "spend": 104586.99,
    //       "cr": 5.1108,
    //       "ctr": 2.856,
    //       "ecpm": 321.3898,
    //       "cpa": 220.18314,
    //       "cpc": 11.253173,
    //       "start_video": 325421,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-20",
    //       "impressions": 425427,
    //       "clicks": 10368,
    //       "conversions": 522,
    //       "spend": 104458.67,
    //       "cr": 5.0347,
    //       "ctr": 2.4371,
    //       "ecpm": 245.5384,
    //       "cpa": 200.1124,
    //       "cpc": 10.075103,
    //       "start_video": 425427,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-21",
    //       "impressions": 425265,
    //       "clicks": 10324,
    //       "conversions": 389,
    //       "spend": 80624.05,
    //       "cr": 3.7679,
    //       "ctr": 2.4277,
    //       "ecpm": 189.58543,
    //       "cpa": 207.25977,
    //       "cpc": 7.809381,
    //       "start_video": 425265,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-22",
    //       "impressions": 370976,
    //       "clicks": 9075,
    //       "conversions": 373,
    //       "spend": 91775.734,
    //       "cr": 4.1102,
    //       "ctr": 2.4462,
    //       "ecpm": 247.38995,
    //       "cpa": 246.04756,
    //       "cpc": 10.113029,
    //       "start_video": 370976,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-23",
    //       "impressions": 400190,
    //       "clicks": 8397,
    //       "conversions": 261,
    //       "spend": 53471.426,
    //       "cr": 3.1083,
    //       "ctr": 2.0983,
    //       "ecpm": 133.6151,
    //       "cpa": 204.87135,
    //       "cpc": 6.36792,
    //       "start_video": 400190,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-24",
    //       "impressions": 470419,
    //       "clicks": 8184,
    //       "conversions": 301,
    //       "spend": 64970.113,
    //       "cr": 3.6779,
    //       "ctr": 1.7397,
    //       "ecpm": 138.11116,
    //       "cpa": 215.84755,
    //       "cpc": 7.9386744,
    //       "start_video": 470419,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-25",
    //       "impressions": 402013,
    //       "clicks": 8070,
    //       "conversions": 366,
    //       "spend": 54111.465,
    //       "cr": 4.5353,
    //       "ctr": 2.0074,
    //       "ecpm": 134.60127,
    //       "cpa": 147.84552,
    //       "cpc": 6.7052617,
    //       "start_video": 402013,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-26",
    //       "impressions": 742767,
    //       "clicks": 10755,
    //       "conversions": 368,
    //       "spend": 70016.25,
    //       "cr": 3.4217,
    //       "ctr": 1.448,
    //       "ecpm": 94.264084,
    //       "cpa": 190.26155,
    //       "cpc": 6.510112,
    //       "start_video": 742767,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-27",
    //       "impressions": 1218814,
    //       "clicks": 15307,
    //       "conversions": 424,
    //       "spend": 59552.836,
    //       "cr": 2.77,
    //       "ctr": 1.2559,
    //       "ecpm": 48.861298,
    //       "cpa": 140.4548,
    //       "cpc": 3.8905623,
    //       "start_video": 1218814,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-28",
    //       "impressions": 1185388,
    //       "clicks": 14335,
    //       "conversions": 309,
    //       "spend": 57985.457,
    //       "cr": 2.1556,
    //       "ctr": 1.2093,
    //       "ecpm": 48.91686,
    //       "cpa": 187.6552,
    //       "cpc": 4.0450263,
    //       "start_video": 1185388,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-29",
    //       "impressions": 1413842,
    //       "clicks": 18231,
    //       "conversions": 279,
    //       "spend": 66573.29,
    //       "cr": 1.5304,
    //       "ctr": 1.2895,
    //       "ecpm": 47.086796,
    //       "cpa": 238.61395,
    //       "cpc": 3.6516533,
    //       "start_video": 1413842,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-30",
    //       "impressions": 1711369,
    //       "clicks": 14836,
    //       "conversions": 303,
    //       "spend": 60190.992,
    //       "cr": 2.0423,
    //       "ctr": 0.8669,
    //       "ecpm": 35.171253,
    //       "cpa": 198.65013,
    //       "cpc": 4.0570903,
    //       "start_video": 1711369,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-05-31",
    //       "impressions": 758733,
    //       "clicks": 8846,
    //       "conversions": 361,
    //       "spend": 47708.37,
    //       "cr": 4.0809,
    //       "ctr": 1.1659,
    //       "ecpm": 62.878998,
    //       "cpa": 132.15614,
    //       "cpc": 5.3932137,
    //       "start_video": 758733,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-01",
    //       "impressions": 742679,
    //       "clicks": 8085,
    //       "conversions": 187,
    //       "spend": 35668.914,
    //       "cr": 2.3129,
    //       "ctr": 1.0886,
    //       "ecpm": 48.02736,
    //       "cpa": 190.74284,
    //       "cpc": 4.4117393,
    //       "start_video": 742679,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-02",
    //       "impressions": 445517,
    //       "clicks": 7362,
    //       "conversions": 293,
    //       "spend": 46842.42,
    //       "cr": 3.9799,
    //       "ctr": 1.6525,
    //       "ecpm": 105.141716,
    //       "cpa": 159.87175,
    //       "cpc": 6.3627305,
    //       "start_video": 445517,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-03",
    //       "impressions": 531925,
    //       "clicks": 5586,
    //       "conversions": 282,
    //       "spend": 43759.043,
    //       "cr": 5.0483,
    //       "ctr": 1.0501,
    //       "ecpm": 82.265434,
    //       "cpa": 155.1739,
    //       "cpc": 7.833699,
    //       "start_video": 531925,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-04",
    //       "impressions": 741909,
    //       "clicks": 7193,
    //       "conversions": 206,
    //       "spend": 70253.38,
    //       "cr": 2.8639,
    //       "ctr": 0.9695,
    //       "ecpm": 94.692726,
    //       "cpa": 341.03583,
    //       "cpc": 9.76691,
    //       "start_video": 741909,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-05",
    //       "impressions": 2923332,
    //       "clicks": 14389,
    //       "conversions": 11,
    //       "spend": 101239.375,
    //       "cr": 0.0764,
    //       "ctr": 0.4922,
    //       "ecpm": 34.6315,
    //       "cpa": 9203.579,
    //       "cpc": 7.035887,
    //       "start_video": 2923332,
    //       "first_quartile": 1743011.0,
    //       "second_quartile": 1592213.0,
    //       "third_quartile": 1478110.0,
    //       "complete_view": 1383731.0,
    //       "vcr": 68.7622
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-06",
    //       "impressions": 828986,
    //       "clicks": 7829,
    //       "conversions": 13,
    //       "spend": 82628.195,
    //       "cr": 0.166,
    //       "ctr": 0.9444,
    //       "ecpm": 99.67381,
    //       "cpa": 6356.015,
    //       "cpc": 10.554119,
    //       "start_video": 828986,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-07",
    //       "impressions": 1091000,
    //       "clicks": 8702,
    //       "conversions": 110,
    //       "spend": 86211.08,
    //       "cr": 1.2641,
    //       "ctr": 0.7976,
    //       "ecpm": 79.02023,
    //       "cpa": 783.73706,
    //       "cpc": 9.907042,
    //       "start_video": 1091000,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-08",
    //       "impressions": 1401090,
    //       "clicks": 8840,
    //       "conversions": 17,
    //       "spend": 79440.375,
    //       "cr": 0.1923,
    //       "ctr": 0.6309,
    //       "ecpm": 56.698982,
    //       "cpa": 4672.9634,
    //       "cpc": 8.986468,
    //       "start_video": 1401090,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-09",
    //       "impressions": 2185083,
    //       "clicks": 12345,
    //       "conversions": 13,
    //       "spend": 76694.86,
    //       "cr": 0.1053,
    //       "ctr": 0.565,
    //       "ecpm": 35.09929,
    //       "cpa": 5899.6045,
    //       "cpc": 6.212625,
    //       "start_video": 2185083,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-10",
    //       "impressions": 2099231,
    //       "clicks": 13968,
    //       "conversions": 21,
    //       "spend": 97025.65,
    //       "cr": 0.1503,
    //       "ctr": 0.6654,
    //       "ecpm": 46.219616,
    //       "cpa": 4620.269,
    //       "cpc": 6.946281,
    //       "start_video": 2099231,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-11",
    //       "impressions": 1433200,
    //       "clicks": 10973,
    //       "conversions": 26,
    //       "spend": 89440.94,
    //       "cr": 0.2369,
    //       "ctr": 0.7656,
    //       "ecpm": 62.40646,
    //       "cpa": 3440.0361,
    //       "cpc": 8.151002,
    //       "start_video": 1433200,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-12",
    //       "impressions": 1637198,
    //       "clicks": 11720,
    //       "conversions": 26,
    //       "spend": 86290.82,
    //       "cr": 0.2218,
    //       "ctr": 0.7159,
    //       "ecpm": 52.706406,
    //       "cpa": 3318.878,
    //       "cpc": 7.362698,
    //       "start_video": 1637198,
    //       "first_quartile": 621.0,
    //       "second_quartile": 368.0,
    //       "third_quartile": 304.0,
    //       "complete_view": 234.0,
    //       "vcr": 13.7485
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-13",
    //       "impressions": 2874619,
    //       "clicks": 14306,
    //       "conversions": 15,
    //       "spend": 88249.96,
    //       "cr": 0.1049,
    //       "ctr": 0.4977,
    //       "ecpm": 30.699705,
    //       "cpa": 5883.3306,
    //       "cpc": 6.1687374,
    //       "start_video": 2874619,
    //       "first_quartile": 42382.0,
    //       "second_quartile": 21195.0,
    //       "third_quartile": 15140.0,
    //       "complete_view": 11370.0,
    //       "vcr": 34.5965
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-14",
    //       "impressions": 3933959,
    //       "clicks": 14372,
    //       "conversions": 18,
    //       "spend": 85409.38,
    //       "cr": 0.1252,
    //       "ctr": 0.3653,
    //       "ecpm": 21.710796,
    //       "cpa": 4744.9653,
    //       "cpc": 5.9427624,
    //       "start_video": 3933959,
    //       "first_quartile": 83692.0,
    //       "second_quartile": 45386.0,
    //       "third_quartile": 26590.0,
    //       "complete_view": 14841.0,
    //       "vcr": 26.0955
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-15",
    //       "impressions": 3815643,
    //       "clicks": 13296,
    //       "conversions": 1432,
    //       "spend": 109345.71,
    //       "cr": 10.7702,
    //       "ctr": 0.3485,
    //       "ecpm": 28.657219,
    //       "cpa": 76.35874,
    //       "cpc": 8.223955,
    //       "start_video": 3815643,
    //       "first_quartile": 89474.0,
    //       "second_quartile": 49241.0,
    //       "third_quartile": 26567.0,
    //       "complete_view": 18412.0,
    //       "vcr": 33.2901
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-16",
    //       "impressions": 4011907,
    //       "clicks": 32019,
    //       "conversions": 3362,
    //       "spend": 176269.02,
    //       "cr": 10.5,
    //       "ctr": 0.7981,
    //       "ecpm": 43.936466,
    //       "cpa": 52.42981,
    //       "cpc": 5.5051384,
    //       "start_video": 4011907,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-17",
    //       "impressions": 3029559,
    //       "clicks": 44862,
    //       "conversions": 2212,
    //       "spend": 171356.92,
    //       "cr": 4.9307,
    //       "ctr": 1.4808,
    //       "ecpm": 56.561672,
    //       "cpa": 77.466965,
    //       "cpc": 3.8196452,
    //       "start_video": 3029559,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-18",
    //       "impressions": 2206668,
    //       "clicks": 29914,
    //       "conversions": 987,
    //       "spend": 142709.1,
    //       "cr": 3.2995,
    //       "ctr": 1.3556,
    //       "ecpm": 64.67176,
    //       "cpa": 144.58876,
    //       "cpc": 4.770646,
    //       "start_video": 2206668,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-19",
    //       "impressions": 1402594,
    //       "clicks": 12813,
    //       "conversions": 178,
    //       "spend": 106128.5,
    //       "cr": 1.3892,
    //       "ctr": 0.9135,
    //       "ecpm": 75.66587,
    //       "cpa": 596.22754,
    //       "cpc": 8.282877,
    //       "start_video": 1402594,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-20",
    //       "impressions": 1035761,
    //       "clicks": 14115,
    //       "conversions": 928,
    //       "spend": 140931.95,
    //       "cr": 6.5746,
    //       "ctr": 1.3628,
    //       "ecpm": 136.0661,
    //       "cpa": 151.86633,
    //       "cpc": 9.984552,
    //       "start_video": 1035761,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-21",
    //       "impressions": 883775,
    //       "clicks": 9709,
    //       "conversions": 865,
    //       "spend": 121534.51,
    //       "cr": 8.9093,
    //       "ctr": 1.0986,
    //       "ecpm": 137.51747,
    //       "cpa": 140.50232,
    //       "cpc": 12.517716,
    //       "start_video": 883775,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-22",
    //       "impressions": 1335623,
    //       "clicks": 23836,
    //       "conversions": 1608,
    //       "spend": 101231.62,
    //       "cr": 6.7461,
    //       "ctr": 1.7846,
    //       "ecpm": 75.79356,
    //       "cpa": 62.954987,
    //       "cpc": 4.2470055,
    //       "start_video": 1335623,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-23",
    //       "impressions": 766802,
    //       "clicks": 12114,
    //       "conversions": 1069,
    //       "spend": 99745.62,
    //       "cr": 8.8245,
    //       "ctr": 1.5798,
    //       "ecpm": 130.08002,
    //       "cpa": 93.30741,
    //       "cpc": 8.233912,
    //       "start_video": 766802,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-24",
    //       "impressions": 612052,
    //       "clicks": 10010,
    //       "conversions": 1143,
    //       "spend": 91809.56,
    //       "cr": 11.4186,
    //       "ctr": 1.6355,
    //       "ecpm": 150.00288,
    //       "cpa": 80.323326,
    //       "cpc": 9.171784,
    //       "start_video": 612052,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-25",
    //       "impressions": 336609,
    //       "clicks": 5987,
    //       "conversions": 921,
    //       "spend": 89998.89,
    //       "cr": 15.3833,
    //       "ctr": 1.7786,
    //       "ecpm": 267.36923,
    //       "cpa": 97.718666,
    //       "cpc": 15.032385,
    //       "start_video": 336609,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-26",
    //       "impressions": 311453,
    //       "clicks": 5854,
    //       "conversions": 1242,
    //       "spend": 78654.89,
    //       "cr": 21.2163,
    //       "ctr": 1.8796,
    //       "ecpm": 252.54176,
    //       "cpa": 63.32922,
    //       "cpc": 13.436093,
    //       "start_video": 311453,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-27",
    //       "impressions": 369399,
    //       "clicks": 6234,
    //       "conversions": 1550,
    //       "spend": 64959.86,
    //       "cr": 24.8637,
    //       "ctr": 1.6876,
    //       "ecpm": 175.85283,
    //       "cpa": 41.909588,
    //       "cpc": 10.420254,
    //       "start_video": 369399,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-28",
    //       "impressions": 255555,
    //       "clicks": 4144,
    //       "conversions": 432,
    //       "spend": 59416.77,
    //       "cr": 10.4247,
    //       "ctr": 1.6216,
    //       "ecpm": 232.50092,
    //       "cpa": 137.53882,
    //       "cpc": 14.338023,
    //       "start_video": 255555,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-29",
    //       "impressions": 540108,
    //       "clicks": 14375,
    //       "conversions": 719,
    //       "spend": 71728.33,
    //       "cr": 5.0017,
    //       "ctr": 2.6615,
    //       "ecpm": 132.80368,
    //       "cpa": 99.76124,
    //       "cpc": 4.9897966,
    //       "start_video": 540108,
    //       "first_quartile": 298.0,
    //       "second_quartile": 168.0,
    //       "third_quartile": 119.0,
    //       "complete_view": 84.0,
    //       "vcr": 3.3058
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-06-30",
    //       "impressions": 409573,
    //       "clicks": 8448,
    //       "conversions": 901,
    //       "spend": 70404.62,
    //       "cr": 10.6652,
    //       "ctr": 2.0626,
    //       "ecpm": 171.89761,
    //       "cpa": 78.14053,
    //       "cpc": 8.33388,
    //       "start_video": 409573,
    //       "first_quartile": 529.0,
    //       "second_quartile": 293.0,
    //       "third_quartile": 187.0,
    //       "complete_view": 130.0,
    //       "vcr": 3.9478
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-01",
    //       "impressions": 613122,
    //       "clicks": 11057,
    //       "conversions": 1020,
    //       "spend": 71511.57,
    //       "cr": 9.2249,
    //       "ctr": 1.8034,
    //       "ecpm": 116.63514,
    //       "cpa": 70.10938,
    //       "cpc": 6.4675384,
    //       "start_video": 613122,
    //       "first_quartile": 477.0,
    //       "second_quartile": 238.0,
    //       "third_quartile": 144.0,
    //       "complete_view": 99.0,
    //       "vcr": 2.64
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-02",
    //       "impressions": 658788,
    //       "clicks": 7655,
    //       "conversions": 1896,
    //       "spend": 89733.43,
    //       "cr": 24.7681,
    //       "ctr": 1.162,
    //       "ecpm": 136.20987,
    //       "cpa": 47.32776,
    //       "cpc": 11.7221985,
    //       "start_video": 658788,
    //       "first_quartile": 648.0,
    //       "second_quartile": 302.0,
    //       "third_quartile": 210.0,
    //       "complete_view": 136.0,
    //       "vcr": 2.3743
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-03",
    //       "impressions": 466198,
    //       "clicks": 6346,
    //       "conversions": 2313,
    //       "spend": 76768.984,
    //       "cr": 36.4482,
    //       "ctr": 1.3612,
    //       "ecpm": 164.67033,
    //       "cpa": 33.19022,
    //       "cpc": 12.097223,
    //       "start_video": 466198,
    //       "first_quartile": 458.0,
    //       "second_quartile": 239.0,
    //       "third_quartile": 140.0,
    //       "complete_view": 87.0,
    //       "vcr": 2.2365
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-04",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-05",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-06",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-07",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-08",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-09",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-10",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-11",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-12",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-13",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-14",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-15",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-16",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     },
    //     {
    //       "platformId": 0,
    //       "sdate": "2023-07-17",
    //       "impressions": 0,
    //       "clicks": 0,
    //       "conversions": 0,
    //       "spend": 0.0,
    //       "cr": 0.0,
    //       "ctr": 0.0,
    //       "ecpm": 0.0,
    //       "cpa": 0.0,
    //       "cpc": 0.0,
    //       "start_video": 0,
    //       "first_quartile": 0.0,
    //       "second_quartile": 0.0,
    //       "third_quartile": 0.0,
    //       "complete_view": 0.0,
    //       "vcr": 0.0
    //     }
    //   ],
    //   "length": 0
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const campaignPerformanceReportDatewiseDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/campaign-performance?list=total&datewise=1&download",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postChannelSpendApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/campaign-performance?list=channelSpend",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    // let data = {"responseCode":{"msg":"List Fetched Successfully","status":"Success","code":200},"responseList":[{"platform":"ION","spends":[{"date":"2023-05-01","spend":0.0},{"date":"2023-05-02","spend":0.0},{"date":"2023-05-03","spend":0.0},{"date":"2023-05-04","spend":0.0},{"date":"2023-05-05","spend":0.0},{"date":"2023-05-06","spend":0.0},{"date":"2023-05-07","spend":0.0},{"date":"2023-05-08","spend":0.0},{"date":"2023-05-09","spend":0.0},{"date":"2023-05-10","spend":0.0},{"date":"2023-05-11","spend":0.0},{"date":"2023-05-12","spend":0.0},{"date":"2023-05-13","spend":0.0},{"date":"2023-05-14","spend":0.0},{"date":"2023-05-15","spend":0.0},{"date":"2023-05-16","spend":0.0},{"date":"2023-05-17","spend":0.0},{"date":"2023-05-18","spend":0.0},{"date":"2023-05-19","spend":0.0},{"date":"2023-05-20","spend":0.0},{"date":"2023-05-21","spend":0.0},{"date":"2023-05-22","spend":0.0},{"date":"2023-05-23","spend":0.0},{"date":"2023-05-24","spend":0.0},{"date":"2023-05-25","spend":0.0},{"date":"2023-05-26","spend":0.0},{"date":"2023-05-27","spend":0.0},{"date":"2023-05-28","spend":0.0},{"date":"2023-05-29","spend":0.0},{"date":"2023-05-30","spend":0.0},{"date":"2023-05-31","spend":0.0},{"date":"2023-06-01","spend":0.0},{"date":"2023-06-02","spend":0.0},{"date":"2023-06-03","spend":0.0},{"date":"2023-06-04","spend":0.0},{"date":"2023-06-05","spend":0.0},{"date":"2023-06-06","spend":0.0},{"date":"2023-06-07","spend":0.0},{"date":"2023-06-08","spend":0.0},{"date":"2023-06-09","spend":0.0},{"date":"2023-06-10","spend":0.0},{"date":"2023-06-11","spend":0.0},{"date":"2023-06-12","spend":0.0},{"date":"2023-06-13","spend":0.0},{"date":"2023-06-14","spend":0.0},{"date":"2023-06-15","spend":0.0},{"date":"2023-06-16","spend":0.0},{"date":"2023-06-17","spend":0.0},{"date":"2023-06-18","spend":0.0},{"date":"2023-06-19","spend":0.0},{"date":"2023-06-20","spend":0.0},{"date":"2023-06-21","spend":0.0},{"date":"2023-06-22","spend":0.0},{"date":"2023-06-23","spend":0.0},{"date":"2023-06-24","spend":0.0},{"date":"2023-06-25","spend":0.0},{"date":"2023-06-26","spend":0.0},{"date":"2023-06-27","spend":0.0},{"date":"2023-06-28","spend":0.0},{"date":"2023-06-29","spend":0.0},{"date":"2023-06-30","spend":0.0},{"date":"2023-07-01","spend":0.0},{"date":"2023-07-02","spend":0.0},{"date":"2023-07-03","spend":0.0},{"date":"2023-07-04","spend":0.0},{"date":"2023-07-05","spend":0.0},{"date":"2023-07-06","spend":0.0},{"date":"2023-07-07","spend":0.0},{"date":"2023-07-08","spend":0.0},{"date":"2023-07-09","spend":0.0},{"date":"2023-07-10","spend":0.0},{"date":"2023-07-11","spend":0.0},{"date":"2023-07-12","spend":0.0},{"date":"2023-07-13","spend":0.0},{"date":"2023-07-14","spend":0.0},{"date":"2023-07-15","spend":0.0},{"date":"2023-07-16","spend":0.0},{"date":"2023-07-17","spend":0.0},{"date":"2023-07-18","spend":0.0},{"date":"2023-07-19","spend":0.0},{"date":"2023-07-20","spend":0.0}]},{"platform":"Facebook","spends":[{"date":"2023-05-01","spend":0.0},{"date":"2023-05-02","spend":0.0},{"date":"2023-05-03","spend":0.0},{"date":"2023-05-04","spend":0.0},{"date":"2023-05-05","spend":0.0},{"date":"2023-05-06","spend":37.45},{"date":"2023-05-07","spend":33.19},{"date":"2023-05-08","spend":41.46},{"date":"2023-05-09","spend":40.29},{"date":"2023-05-10","spend":35.14},{"date":"2023-05-11","spend":17.41},{"date":"2023-05-12","spend":17.69},{"date":"2023-05-13","spend":19.18},{"date":"2023-05-14","spend":41.98},{"date":"2023-05-15","spend":22.88},{"date":"2023-05-16","spend":24.86},{"date":"2023-05-17","spend":24.78},{"date":"2023-05-18","spend":24.01},{"date":"2023-05-19","spend":29.24},{"date":"2023-05-20","spend":36.15},{"date":"2023-05-21","spend":0.0},{"date":"2023-05-22","spend":0.0},{"date":"2023-05-23","spend":0.0},{"date":"2023-05-24","spend":0.0},{"date":"2023-05-25","spend":0.0},{"date":"2023-05-26","spend":0.0},{"date":"2023-05-27","spend":0.0},{"date":"2023-05-28","spend":0.0},{"date":"2023-05-29","spend":0.0},{"date":"2023-05-30","spend":0.0},{"date":"2023-05-31","spend":0.0},{"date":"2023-06-01","spend":0.0},{"date":"2023-06-02","spend":0.0},{"date":"2023-06-03","spend":0.0},{"date":"2023-06-04","spend":0.0},{"date":"2023-06-05","spend":21.25},{"date":"2023-06-06","spend":22.25},{"date":"2023-06-07","spend":19.22},{"date":"2023-06-08","spend":20.41},{"date":"2023-06-09","spend":17.47},{"date":"2023-06-10","spend":19.62},{"date":"2023-06-11","spend":20.05},{"date":"2023-06-12","spend":21.06},{"date":"2023-06-13","spend":20.62},{"date":"2023-06-14","spend":19.74},{"date":"2023-06-15","spend":19.6},{"date":"2023-06-16","spend":19.72},{"date":"2023-06-17","spend":19.21},{"date":"2023-06-18","spend":19.63},{"date":"2023-06-19","spend":28.89},{"date":"2023-06-20","spend":34.48},{"date":"2023-06-21","spend":33.92},{"date":"2023-06-22","spend":32.88},{"date":"2023-06-23","spend":13.27},{"date":"2023-06-24","spend":0.0},{"date":"2023-06-25","spend":0.0},{"date":"2023-06-26","spend":26.08},{"date":"2023-06-27","spend":11.98},{"date":"2023-06-28","spend":0.0},{"date":"2023-06-29","spend":27.29},{"date":"2023-06-30","spend":37.61},{"date":"2023-07-01","spend":38.03},{"date":"2023-07-02","spend":42.6},{"date":"2023-07-03","spend":30.01},{"date":"2023-07-04","spend":0.0},{"date":"2023-07-05","spend":0.0},{"date":"2023-07-06","spend":0.0},{"date":"2023-07-07","spend":0.0},{"date":"2023-07-08","spend":0.0},{"date":"2023-07-09","spend":0.0},{"date":"2023-07-10","spend":0.0},{"date":"2023-07-11","spend":0.0},{"date":"2023-07-12","spend":0.0},{"date":"2023-07-13","spend":0.0},{"date":"2023-07-14","spend":0.0},{"date":"2023-07-15","spend":0.0},{"date":"2023-07-16","spend":0.0},{"date":"2023-07-17","spend":0.0},{"date":"2023-07-18","spend":0.0},{"date":"2023-07-19","spend":0.0},{"date":"2023-07-20","spend":0.0}]},{"platform":"GoogleAdwords","spends":[{"date":"2023-05-01","spend":59201.1304},{"date":"2023-05-02","spend":86018.7995},{"date":"2023-05-03","spend":76359.3787},{"date":"2023-05-04","spend":77079.8491},{"date":"2023-05-05","spend":66963.8201},{"date":"2023-05-06","spend":66808.7693},{"date":"2023-05-07","spend":66810.4996},{"date":"2023-05-08","spend":76517.1904},{"date":"2023-05-09","spend":61676.3202},{"date":"2023-05-10","spend":72103.4201},{"date":"2023-05-11","spend":71557.6899},{"date":"2023-05-12","spend":69207.2106},{"date":"2023-05-13","spend":55760.6392},{"date":"2023-05-14","spend":52785.3308},{"date":"2023-05-15","spend":69284.9403},{"date":"2023-05-16","spend":67665.5204},{"date":"2023-05-17","spend":57634.8399},{"date":"2023-05-18","spend":57186.3306},{"date":"2023-05-19","spend":104557.7504},{"date":"2023-05-20","spend":104422.5188},{"date":"2023-05-21","spend":80624.0495},{"date":"2023-05-22","spend":91775.7379},{"date":"2023-05-23","spend":53326.8804},{"date":"2023-05-24","spend":62158.7503},{"date":"2023-05-25","spend":52777.8098},{"date":"2023-05-26","spend":62398.1808},{"date":"2023-05-27","spend":53225.1302},{"date":"2023-05-28","spend":51658.5598},{"date":"2023-05-29","spend":60709.5102},{"date":"2023-05-30","spend":58121.2897},{"date":"2023-05-31","spend":47708.3699},{"date":"2023-06-01","spend":35668.9122},{"date":"2023-06-02","spend":46053.0697},{"date":"2023-06-03","spend":43022.8201},{"date":"2023-06-04","spend":69499.2602},{"date":"2023-06-05","spend":84615.7307},{"date":"2023-06-06","spend":81882.6903},{"date":"2023-06-07","spend":85469.9298},{"date":"2023-06-08","spend":78015.4205},{"date":"2023-06-09","spend":74046.6},{"date":"2023-06-10","spend":94878.6991},{"date":"2023-06-11","spend":88130.0592},{"date":"2023-06-12","spend":84745.6892},{"date":"2023-06-13","spend":82113.9205},{"date":"2023-06-14","spend":77350.4404},{"date":"2023-06-15","spend":101876.7393},{"date":"2023-06-16","spend":172540.7385},{"date":"2023-06-17","spend":170168.5091},{"date":"2023-06-18","spend":141613.5287},{"date":"2023-06-19","spend":105084.9408},{"date":"2023-06-20","spend":140897.4808},{"date":"2023-06-21","spend":121499.4313},{"date":"2023-06-22","spend":101198.7391},{"date":"2023-06-23","spend":99732.3507},{"date":"2023-06-24","spend":91809.5608},{"date":"2023-06-25","spend":89998.8894},{"date":"2023-06-26","spend":78628.809},{"date":"2023-06-27","spend":64947.8796},{"date":"2023-06-28","spend":59416.7697},{"date":"2023-06-29","spend":71701.039},{"date":"2023-06-30","spend":70367.0087},{"date":"2023-07-01","spend":71473.5403},{"date":"2023-07-02","spend":89690.83},{"date":"2023-07-03","spend":76738.9715},{"date":"2023-07-04","spend":0.0},{"date":"2023-07-05","spend":0.0},{"date":"2023-07-06","spend":0.0},{"date":"2023-07-07","spend":0.0},{"date":"2023-07-08","spend":0.0},{"date":"2023-07-09","spend":0.0},{"date":"2023-07-10","spend":0.0},{"date":"2023-07-11","spend":0.0},{"date":"2023-07-12","spend":0.0},{"date":"2023-07-13","spend":0.0},{"date":"2023-07-14","spend":0.0},{"date":"2023-07-15","spend":0.0},{"date":"2023-07-16","spend":0.0},{"date":"2023-07-17","spend":0.0},{"date":"2023-07-18","spend":0.0},{"date":"2023-07-19","spend":0.0},{"date":"2023-07-20","spend":0.0}]},{"platform":"DV360","spends":[{"date":"2023-05-01","spend":0.0},{"date":"2023-05-02","spend":0.0},{"date":"2023-05-03","spend":0.0},{"date":"2023-05-04","spend":0.0},{"date":"2023-05-05","spend":0.0},{"date":"2023-05-06","spend":0.0},{"date":"2023-05-07","spend":0.0},{"date":"2023-05-08","spend":0.0},{"date":"2023-05-09","spend":0.0},{"date":"2023-05-10","spend":0.0},{"date":"2023-05-11","spend":0.0},{"date":"2023-05-12","spend":0.0},{"date":"2023-05-13","spend":0.0},{"date":"2023-05-14","spend":0.0},{"date":"2023-05-15","spend":0.0},{"date":"2023-05-16","spend":0.0},{"date":"2023-05-17","spend":0.0},{"date":"2023-05-18","spend":0.0},{"date":"2023-05-19","spend":0.0},{"date":"2023-05-20","spend":0.0},{"date":"2023-05-21","spend":0.0},{"date":"2023-05-22","spend":0.0},{"date":"2023-05-23","spend":144.5442},{"date":"2023-05-24","spend":2811.3633},{"date":"2023-05-25","spend":1333.6532},{"date":"2023-05-26","spend":7618.0693},{"date":"2023-05-27","spend":6327.7056},{"date":"2023-05-28","spend":6326.8955},{"date":"2023-05-29","spend":5863.7808},{"date":"2023-05-30","spend":2069.7019},{"date":"2023-05-31","spend":0.0},{"date":"2023-06-01","spend":0.0},{"date":"2023-06-02","spend":789.3535},{"date":"2023-06-03","spend":736.2227},{"date":"2023-06-04","spend":754.123},{"date":"2023-06-05","spend":16602.3932},{"date":"2023-06-06","spend":723.2582},{"date":"2023-06-07","spend":721.9284},{"date":"2023-06-08","spend":1404.5456},{"date":"2023-06-09","spend":2630.786},{"date":"2023-06-10","spend":2127.3303},{"date":"2023-06-11","spend":1290.8314},{"date":"2023-06-12","spend":1524.0743},{"date":"2023-06-13","spend":6115.4172},{"date":"2023-06-14","spend":8039.1996},{"date":"2023-06-15","spend":7449.3744},{"date":"2023-06-16","spend":3708.563},{"date":"2023-06-17","spend":1169.2067},{"date":"2023-06-18","spend":1075.9427},{"date":"2023-06-19","spend":1014.6706},{"date":"2023-06-20","spend":0.0},{"date":"2023-06-21","spend":1.153},{"date":"2023-06-22","spend":0.0},{"date":"2023-06-23","spend":0.0},{"date":"2023-06-24","spend":0.0},{"date":"2023-06-25","spend":0.0},{"date":"2023-06-26","spend":0.0},{"date":"2023-06-27","spend":0.0},{"date":"2023-06-28","spend":0.0},{"date":"2023-06-29","spend":0.0},{"date":"2023-06-30","spend":0.0},{"date":"2023-07-01","spend":0.0},{"date":"2023-07-02","spend":0.0},{"date":"2023-07-03","spend":0.0},{"date":"2023-07-04","spend":0.0},{"date":"2023-07-05","spend":0.0},{"date":"2023-07-06","spend":0.0},{"date":"2023-07-07","spend":0.0},{"date":"2023-07-08","spend":0.0},{"date":"2023-07-09","spend":0.0},{"date":"2023-07-10","spend":0.0},{"date":"2023-07-11","spend":0.0},{"date":"2023-07-12","spend":0.0},{"date":"2023-07-13","spend":0.0},{"date":"2023-07-14","spend":0.0},{"date":"2023-07-15","spend":0.0},{"date":"2023-07-16","spend":0.0},{"date":"2023-07-17","spend":0.0},{"date":"2023-07-18","spend":0.0},{"date":"2023-07-19","spend":0.0},{"date":"2023-07-20","spend":0.0}]},{"platform":"TikTok","spends":[{"date":"2023-05-01","spend":0.0},{"date":"2023-05-02","spend":0.0},{"date":"2023-05-03","spend":0.0},{"date":"2023-05-04","spend":0.0},{"date":"2023-05-05","spend":0.0},{"date":"2023-05-06","spend":0.0},{"date":"2023-05-07","spend":0.0},{"date":"2023-05-08","spend":0.0},{"date":"2023-05-09","spend":0.0},{"date":"2023-05-10","spend":0.0},{"date":"2023-05-11","spend":0.0},{"date":"2023-05-12","spend":0.0},{"date":"2023-05-13","spend":0.0},{"date":"2023-05-14","spend":0.0},{"date":"2023-05-15","spend":0.0},{"date":"2023-05-16","spend":0.0},{"date":"2023-05-17","spend":0.0},{"date":"2023-05-18","spend":0.0},{"date":"2023-05-19","spend":0.0},{"date":"2023-05-20","spend":0.0},{"date":"2023-05-21","spend":0.0},{"date":"2023-05-22","spend":0.0},{"date":"2023-05-23","spend":0.0},{"date":"2023-05-24","spend":0.0},{"date":"2023-05-25","spend":0.0},{"date":"2023-05-26","spend":0.0},{"date":"2023-05-27","spend":0.0},{"date":"2023-05-28","spend":0.0},{"date":"2023-05-29","spend":0.0},{"date":"2023-05-30","spend":0.0},{"date":"2023-05-31","spend":0.0},{"date":"2023-06-01","spend":0.0},{"date":"2023-06-02","spend":0.0},{"date":"2023-06-03","spend":0.0},{"date":"2023-06-04","spend":0.0},{"date":"2023-06-05","spend":0.0},{"date":"2023-06-06","spend":0.0},{"date":"2023-06-07","spend":0.0},{"date":"2023-06-08","spend":0.0},{"date":"2023-06-09","spend":0.0},{"date":"2023-06-10","spend":0.0},{"date":"2023-06-11","spend":0.0},{"date":"2023-06-12","spend":0.0},{"date":"2023-06-13","spend":0.0},{"date":"2023-06-14","spend":0.0},{"date":"2023-06-15","spend":0.0},{"date":"2023-06-16","spend":0.0},{"date":"2023-06-17","spend":0.0},{"date":"2023-06-18","spend":0.0},{"date":"2023-06-19","spend":0.0},{"date":"2023-06-20","spend":0.0},{"date":"2023-06-21","spend":0.0},{"date":"2023-06-22","spend":0.0},{"date":"2023-06-23","spend":0.0},{"date":"2023-06-24","spend":0.0},{"date":"2023-06-25","spend":0.0},{"date":"2023-06-26","spend":0.0},{"date":"2023-06-27","spend":0.0},{"date":"2023-06-28","spend":0.0},{"date":"2023-06-29","spend":0.0},{"date":"2023-06-30","spend":0.0},{"date":"2023-07-01","spend":0.0},{"date":"2023-07-02","spend":0.0},{"date":"2023-07-03","spend":0.0},{"date":"2023-07-04","spend":0.0},{"date":"2023-07-05","spend":0.0},{"date":"2023-07-06","spend":0.0},{"date":"2023-07-07","spend":0.0},{"date":"2023-07-08","spend":0.0},{"date":"2023-07-09","spend":0.0},{"date":"2023-07-10","spend":0.0},{"date":"2023-07-11","spend":0.0},{"date":"2023-07-12","spend":0.0},{"date":"2023-07-13","spend":0.0},{"date":"2023-07-14","spend":0.0},{"date":"2023-07-15","spend":0.0},{"date":"2023-07-16","spend":0.0},{"date":"2023-07-17","spend":0.0},{"date":"2023-07-18","spend":0.0},{"date":"2023-07-19","spend":0.0},{"date":"2023-07-20","spend":0.0}]}],"length":0}
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postGeoReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/geo-performance?list=india",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postAgeGenderCampaignIdApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/age-gender-performance?campaignId=${campaignId}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postGeoCampaignIdApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/geo-performance?campaignId=${campaignId}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const postCreativeReportTableApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/creative-performance?campaignId=${campaignId}&creativewise=1`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};






// postCampaignPerformanceWithOffsetApi

export const postCampaignPerformanceWithOffsetApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  offset,
  pageLimit
}) => {
  try {
    // console.log(offset, "API");
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=all&offset=${offset}&limit=${pageLimit}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postCreativeReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  offset,
  pageLimit
}) => {
  try {
    // console.log(offset, "API");
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=all&offset=${offset}&limit=${pageLimit}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postAgeGenderReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/age-gender-performance?list=all",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postRecoImplementationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/reco-vs-impl?list=all",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getTagldMappingDownloadCSVApi = async ({
  tenantId,
  authToken,
  userId,
  downloadCSV,
}) => {
  try {
    const { data } = await client().get(endPoints.adUnitMap, {
      params: downloadCSV,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteTagMapApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.adUnitMap, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// =========== start advertiser api's ============
export const createAdvertiserApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    // const { data } = await client().post(endPoints.atd + "/advertiser?action=create",
    const { data } = await client().post(endPoints.atd + `/advertiser?action=create`,
      // const { data } = await client().post(`https://stageatdv2.torcai.com/report-atd/advertiser?action=create`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const listAdvertiserApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    // const { data } = await client().post(
    //   endPoints.atd + `/advertiser?action=list&id=${tenantId}`,
    const { data } = await client().post(endPoints.atd + `/advertiser?action=list&id=${tenantId}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// editAdvertiserListApi
export const editAdvertiserListApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  advertiserId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + `/advertiser?action=list&id=${advertiserId}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const updateAdvertiserApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/advertiser?action=update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
// =========== end advertiser api's ============

export const getTagldMappingListadunitAllApi = async ({
  tenantId,
  authToken,
  userId,
  getId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.adUnitMap + "?listadunit=all",
      {
        params: getId,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const tagldMappingAddAdunitmapApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.adUnitMap, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// bulk upload
export const uploadSiteFileBulkCSVApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client({ multipart: false }).patch(
      endPoints.adUnitBulk + `?bulkadd=auto`,
      payload,
      {
        headers: {
          common: {
            "Content-Type": "multipart/form-data",
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const gettagldMappingBulkListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.adUnitBulk + "?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const tagldMappingBulkDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  downloadObj,
}) => {
  try {
    const { data } = await client().get(endPoints.adUnitBulk, {
      params: downloadObj,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// admin Supply Partner List Api
export const getAdminSupplypartnerListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypartner/Torcai?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// dashboard api ion
export const getMediaReportApi = async ({
  tenantId,
  authToken,
  userId,
  mediaReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/mediareport",
      mediaReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getQpsReportApi = async ({
  tenantId,
  authToken,
  userId,
  qpsReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/qps",
      qpsReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRevenueReportApi = async ({
  tenantId,
  authToken,
  userId,
  revenueReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/billingreport",
      revenueReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIonExchangeApi = async ({
  tenantId,
  authToken,
  userId,
  ionExchangeReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/ionreport",
      ionExchangeReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIonExchangeDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  ionExchangeReqBodyDownload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/ionreport?action=Download",
      ionExchangeReqBodyDownload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIonExchangeSupplyPartnerListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.ionReport + "/list/custom?filter=supplypartner",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdminTenantSupplypartnerListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypartner/Torcai?action=tenantlist",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// admin Variable  Api
// export const getAdminVariableListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/saveupdate/Torcai?type=attributes&action=list',
//             {
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getAdminVariableListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/config?action=list&type=all",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const configAttributeApi = async ({
  tenantId,
  authToken,
  userId,
  type
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + `/config?action=list&type=${type}`,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const addAdminVariableApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/saveupdate/Torcai?type=attributes', payload,
//             {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addAdminVariableApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/config?action=addup&type=attributes",
      [payload],
      {
        // params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getUserReachReportApi = async (
  tenantId,
  authToken,
  userId,
  campaignPerformanceReportReqBody
) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/userreach?list",
      campaignPerformanceReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// admin User  Api

export const getAdminUserListApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    if (Object.keys(params).length == 0) {
      const { data } = await client({ auth: true }).get(endPoints.auth + "/user?list=all", {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      });
      return data;
    } else {
      const { data } = await client({ auth: true }).get(endPoints.auth + "/user", {
        params,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      });
      return data;
    }
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getUserListByEmailApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/user", {
      params,
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;

  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getSelfRegisterEmailApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/self-register/user", {
      params
    });
    return data;

  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdminUserSingleListApi = async ({
  tenantId,
  authToken,
  userId,
  id,
}) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/user?list=" + id, {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAdminUserApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/user?addup=" + addParams,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// admin Roles Api
export const getRolesListApi = async ({
  tenantId,
  authToken,
  userId,
  addParams = "byuser",
  params,
}) => {
  try {
    // console.log("call");
    if (Number(params) > 0) {
      addParams = `byplatform&id=${params}`;
    }
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/role?list=" + addParams,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdminRoleSingleListApi = async ({
  tenantId,
  authToken,
  userId,
  id,
}) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/role?list=" + id, {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAdminRolesApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      // endPoints.auth + '/saveupdate/Torcai?type=role', payload,
      endPoints.auth + "/role",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDemandpartnerSeatListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/agreement?action=demandseat",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
// admin currency rate list
export const getCurrencyRateListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/currency?list=all", {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const addCurrencyRateApi = async (
  tenantId,
  authToken,
  userId,
  payload
) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/currency?addup=auto",
      payload,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
// admin Demand Partner  List Api

export const getDemandpartnerListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/demandpartner/Torcai?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAdminDemandPartnerApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/demandpartner/Torcai",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDemandPartnerNamesFilterApi = async ({
  tenantId,
  authToken,
  userId,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/demandpartner/Torcai?action=getids",
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getTenantDemandpartnerListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/demandpartner/Torcai?action=tenantlist",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// admin agreement List Api
export const getAgreementListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/agreement?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const addAdminAgreementApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/agreement",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAgreementConnectionListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/connection?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

// export const addAdminAgreementApi = async ({ tenantId, authToken, userId,  deleteId }) => {
//     try {
//         const { data } = await client().post(
//             '/authentication/agreement?action=delete', payload,
//             {
//                 params: deleteId,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

// admin Supplypath List Api

export const getIONSupplypathListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypath?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getPVTSupplypathListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/agreement?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateIONSupplypathApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/supplypath?action=update",
      payload,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---- *  Bidder api call * -------

export const getBidderReportApi = async ({
  tenantId,
  authToken,
  userId,
  bidderReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/bidderreport",
      bidderReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
//---mediaPlanning report Api call--------

export const getMediaSaveReportApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/scheduledreport?list=all",
      { filters: { reportType: 2 } },
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    // const { data } = await client().get(
    //     endPoints.bidder + '/mediascheduledreport?action=list', {
    //     headers: {
    //         common: {
    //             'tai_tenant': parseInt(tenantId),
    //             'tai_token': authToken,
    //             'tai_user': userId,
    //         }
    //     }
    // }
    // );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const getMediaPlanningReportApi = async ({
  tenantId,
  authToken,
  userId,
  mediaPlanningReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/mediaplanning",
      mediaPlanningReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getGenerateReportApi = async ({
  tenantId,
  authToken,
  userId,
  mediaPlanningReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/scheduledreport?addup=auto",
      mediaPlanningReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    let a = {
      responeCode: {
        status: "success",
        code: 200,
        msg: "",
      },
      response: [
        {
          os: "linux",
          totalRequest: 12,
          eCPM: 200.0,
          maxBid: 100.0,
          avgBidFloor: 5.0,
          totalBusinessReq: 20,
        },
      ],
    };
    return a;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const getRefreshReportApi = async ({
  tenantId,
  authToken,
  userId,
  rowId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/scheduledreport?action=" + rowId,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---- *  CampaignPerformance api call * -------

export const getCampaignPerformanceReportApi = async ({
  tenantId,
  authToken,
  userId,
  campaignPerformanceReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/campaignreport",
      campaignPerformanceReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addSaveReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/scheduledreport?addup=auto",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const refreshSaveReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  id,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + `/scheduledreport?action=${id}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignPerformanceReportFilterListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.bidder + "/custom", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getSaveReportApi = async ({
  tenantId,
  authToken,
  userId,
  type,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/scheduledreport?list=all",
      { filters: { reportType: type } },
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignListAllReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.campaign + "?list=all",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignEditIdReportApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.campaign, {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let a = {
    //     "campaign": {
    //         "campaignId": 650,
    //         "tenantId": 28,
    //         "ioId": 65,
    //         "advertiserId": 26,
    //         "recActive": 1,
    //         "budget": 9967,
    //         "campaignName": "Testing_Video_Feb17_640x360_1",
    //         "timeZone": "68",
    //         "pacingStyle": 0,
    //         "goal": 90,
    //         "pacingDurtion": 1,
    //         "packingBudget": 789,
    //         "createRecDetails": {
    //             "userName": 51,
    //             "dateTime": "Apr 29, 2022"
    //         },
    //         "modifyRecDetails": {
    //             "userName": 51,
    //             "dateTime": "May 9, 2022"
    //         },
    //         "isActive": 1,
    //         "ioName": "test_IO_for_budget",
    //         "goalCost": 0,
    //         "budgetLeft": 0,
    //         "advertiserName": "testing",
    //         "adContentType": 2,
    //         "category": [
    //             {
    //                 "categoryId": 166,
    //                 "categoryType": 1,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "May 9, 2022"
    //                 },
    //                 "ti_isactive": 1
    //             },
    //             {
    //                 "categoryId": 234,
    //                 "categoryType": 2,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "May 9, 2022"
    //                 },
    //                 "ti_isactive": 1
    //             }
    //         ],
    //         "budgetSpent": [],
    //         "flight": [
    //             {
    //                 "startDate": "Apr 29, 2022 00:00:00",
    //                 "endDate": "Jun 04, 2022 23:59:00",
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "May 9, 2022"
    //                 },
    //                 "ti_isactive": 1
    //             }
    //         ],
    //         "strategies": [
    //             {
    //                 "strategyId": 678,
    //                 "campaignId": 650,
    //                 "strategyName": "Testing_Video_Feb17_640x360_1",
    //                 "totalBudget": 9967,
    //                 "currency": 70,
    //                 "startDate": "Apr 29, 2022 00:00:00",
    //                 "endDate": "",
    //                 "isCarryForward": 0,
    //                 "minimumBid": 21,
    //                 "maximumBid": 999,
    //                 "pacingStyle": 0,
    //                 "pacingDuration": 1,
    //                 "pacingBudget": 84,
    //                 "goalType": 90,
    //                 "userFrequencyCap": 5,
    //                 "recActive": 1,
    //                 "createRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "Apr 29, 2022"
    //                 },
    //                 "modifyRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "May 9, 2022"
    //                 },
    //                 "ti_isactive": 1,
    //                 "filter": [
    //                     {
    //                         "filter": 84,
    //                         "createRecDetails": {},
    //                         "modifyRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "ti_isactive": 1,
    //                         "inex": 1,
    //                         "filter_type": 0
    //                     },
    //                     {
    //                         "filter": 85,
    //                         "createRecDetails": {},
    //                         "modifyRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "ti_isactive": 1,
    //                         "inex": 1,
    //                         "filter_type": 0
    //                     },
    //                     {
    //                         "filter": 86,
    //                         "createRecDetails": {},
    //                         "modifyRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "ti_isactive": 1,
    //                         "inex": 1,
    //                         "filter_type": 0
    //                     }
    //                 ],
    //                 "flight": [
    //                     {
    //                         "day": "0,1,2,3,4,5,6",
    //                         "time": "00.00,23.30",
    //                         "endDate": "",
    //                         "startDate": "Apr 29, 2022",
    //                         "createRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "modifyRecDetails": {},
    //                         "ti_isactive": 1,
    //                         "timeZone": "68"
    //                     },
    //                     {
    //                         "day": "0,1,2,3,4,5,6",
    //                         "time": "03.00,19.30",
    //                         "endDate": "",
    //                         "startDate": "Apr 29, 2022",
    //                         "createRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "modifyRecDetails": {},
    //                         "ti_isactive": 1,
    //                         "timeZone": "68"
    //                     }
    //                 ],
    //                 "list": [],
    //                 "pi": [
    //                     {
    //                         "request": 0,
    //                         "response": 0,
    //                         "impression": 0,
    //                         "win": 0,
    //                         "loss": 0,
    //                         "ctr": 0,
    //                         "click": 0
    //                     }
    //                 ],
    //                 "audience": [],
    //                 "creative": [
    //                     {
    //                         "strategyId": 678,
    //                         "globalCreativeId": 434,
    //                         "frequencyCap": 5,
    //                         "position": 0,
    //                         "attribute": 0,
    //                         "multiPosition": "",
    //                         "multiAttribute": "",
    //                         "recActive": 1,
    //                         "createRecDetails": {},
    //                         "modifyRecDetails": {
    //                             "userName": 51,
    //                             "dateTime": "May 9, 2022"
    //                         },
    //                         "ti_isactive": 1,
    //                         "trackerFlag": 1,
    //                         "linearity": "",
    //                         "creativeTrackers": []
    //                     }
    //                 ],
    //                 "geo": [],
    //                 "exchange": [
    //                     {
    //                         "exchngId": -1,
    //                         "isActive": 1,
    //                         "createRecDetails": {
    //                             "userId": 0
    //                         },
    //                         "modifyRecDetails": {
    //                             "userId": 51,
    //                             "dateTime": "May 9, 2022"
    //                         }
    //                     }
    //                 ],
    //                 "device": [],
    //                 "count": []
    //             }
    //         ],
    //         "pmp": [
    //             {
    //                 "dealId": "Testing_Video_Feb17_640x360",
    //                 "pmpId": 141
    //             }
    //         ],
    //         "pi": [
    //             {
    //                 "request": 0,
    //                 "response": 0,
    //                 "impression": 0,
    //                 "win": 0,
    //                 "loss": 0,
    //                 "ctr": 0,
    //                 "click": 0
    //             }
    //         ],
    //         "tracker": [
    //             {
    //                 "impressionPixel": "",
    //                 "clickPixel": "",
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 51,
    //                     "dateTime": "May 9, 2022"
    //                 },
    //                 "ti_isactive": 1
    //             }
    //         ],
    //         "userJourney": [],
    //         "currency": [
    //             {
    //                 "currency": 70,
    //                 "exchangeRate": 0,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 45,
    //                     "dateTime": "Nov 17, 2021"
    //                 },
    //                 "ti_isactive": 1
    //             },
    //             {
    //                 "currency": 70,
    //                 "exchangeRate": 0,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 45,
    //                     "dateTime": "Nov 17, 2021"
    //                 },
    //                 "ti_isactive": 1
    //             },
    //             {
    //                 "currency": 70,
    //                 "exchangeRate": 0,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 45,
    //                     "dateTime": "Nov 17, 2021"
    //                 },
    //                 "ti_isactive": 1
    //             },
    //             {
    //                 "currency": 70,
    //                 "exchangeRate": 0,
    //                 "createRecDetails": {},
    //                 "modifyRecDetails": {
    //                     "userName": 45,
    //                     "dateTime": "Nov 17, 2021"
    //                 },
    //                 "ti_isactive": 1
    //             }
    //         ]
    //     }
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// campaign  Private Market Place

export const getPrivateMarketPlaceApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.campaignPmp + "?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addPrivateMarketPlaceApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.campaignPmp, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deletePrivateMarketPlaceApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.campaignPmp, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---- * Io * --------
export const getIoListAllReportApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.io + "?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addIoReportApi = async ({
  tenantId,
  authToken,
  userId,
  addIoReqBody,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.io, addIoReqBody, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIoAdvertisersReportApi = async ({
  tenantId,
  authToken,
  userId,
  tenantType,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/tenant?list=bytype&tenantType=advertiser",
      {
        // params: tenantType,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteIoApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.io, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIoEditIdReportApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.io, {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---- * Country/state/city * ----

export const getCountryListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.geo + "?type=country", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getStateListApi = async ({
  tenantId,
  authToken,
  userId,
  countryCode = "",
}) => {
  try {
    const { data } = await client().get(endPoints.geo + "?type=state", {
      params: countryCode,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCityListApi = async ({
  tenantId,
  authToken,
  userId,
  cncode = "",
  scode = "",
}) => {
  let cnscCode;
  if (cncode || scode) {
    cnscCode = { cncode, scode };
  }
  try {
    const { data } = await client().get(endPoints.geo + "?type=city", {
      params: cnscCode,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ------* Campaign * -------

// export const getCampaignSubCategoryReportApi = async ({ valueId }, token) => {
//     try {
//         const { data } = await client().get(endPoints.auth + '/attribute/Torcai', {
//             params: valueId,
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(token.tenantId),
//                     'torc_user': token.userId,
//                     'Authorization': `Bearer ${token.authToken}`
//                 }
//             }
//         });
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getCampaignSubCategoryReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth +
      `/config?action=list&type=${payload.list.join(",")}&value=child`,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    let arr = [];
    if (payload.list.length > 1) {
      Object.keys(data.responseList[0]).forEach((key) => {
        arr = [
          ...arr,
          ...data.responseList[0][key].map((item) => ({
            ...item,
            categoryId: key,
          })),
        ];
      });
      data.responseList = arr;
    }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  addCampaignBody,
  editId,
}) => {
  try {
    const { data } = await client().post(endPoints.campaign, addCampaignBody, {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAdvertiserCreativeGroupApi = async ({
  tenantId,
  authToken,
  userId,
  advertiserId,
}) => {
  try {
    const { data } = await client().post(
      endPoints.creative + "?list=all ",
      { advertiserId },
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.campaign, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignCategoryTypeApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    // const { data } = await client().get(endPoints.auth + '/config/Torcai?type=CAMPAIGN_CATEGORY_TYPE',
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/config?action=list&type=CAMPAIGN_CATEGORY_TYPE",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const getCampaignCategoryTypeApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(endPoints.auth + '/category?category=1',
//             {
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             });

//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

// ---*  Creative * ---
export const addCreativeApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.creative, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getUserReachReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  userReachReportReqBody,
}) => {
  try {
    console.log(userReachReportReqBody);

    const { data } = await client().post(
      endPoints.bidder + "/userreach?download",
      userReachReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteCreativeApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
  advertiserId,
}) => {
  try {
    const { data } = await client().post(endPoints.creative, advertiserId, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editCreativeApi = async ({
  tenantId,
  authToken,
  userId,
  advertiserId,
  editId,
}) => {
  try {
    const { data } = await client().post(endPoints.creative, advertiserId, {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

/* common api */
export const uploadFileActionApi = async ({
  payload,
  advertiserId,
  accept,
}) => {
  console.log("api", advertiserId);

  try {
    const { data } = await client({ multipart: true }).patch(
      `/upload`,
      payload,
      {
        params: {
          advertiserId,
          type: accept,
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const uploadPlatformFileActionApi = async ({
  payload,
  advertiserId,
  accept,
}) => {
  try {
    console.log(payload);
    const { data } = await client({ multipart: true }).patch(
      `/upload-logo`,
      payload,
      {
        params: {
          advertiserId,
          type: accept,
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
// ---- * Admin * ----

// * Tenant api *
export const getTenantApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/tenant?list=all", {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addTenantApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    let isAdd = addParams.action === "create" ? "auto" : payload.tenantId;
    const { data } = await client({ auth: true }).post(
      endPoints.auth + `/tenant?addup=${isAdd}`,
      payload,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteTenantApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/saveupdate/Torcai?type=tenant&action=delete",
      {
        params: deleteId,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editTenantApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + `/tenant?list=${editId}`,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postWalletGetApi = async ({
  tenantId,
  authToken,
  userId,
  id
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.payment + "/fetch/balance",
      id,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postTenantPaymentTypeApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.payment + `/paymentType/addUpdate`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postTenantSupportedPaymentTypesApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.payment + `/paymentType/list`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postTenantSupportedPlatformsApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/miscellanous/platformAccess/${params.type}`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

//http://localhost:9095/authentication/tenant/Torcai?type=tenant&tenantId=4"

// * SupplyPartner  *

// export const getSupplyPartnerApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/supplypartner/Torcai?action=list', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getSupplyPartnerApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypartner/Torcai?action=list",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addSupplyPartnerApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/supplypartner/Torcai",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteSupplyPartnerApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypartner/Torcai?action=delete",
      {
        params: deleteId,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editSupplyPartnerApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/supplypartner/Torcai?action=get",
      {
        params: editId,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ----* Features *----
// export const getListFeatureApi = async ({ tenantId, authToken, userId, type }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/feature', {
//             params: type,
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getListFeatureApi = async ({
  tenantId,
  authToken,
  userId,
  type,
}) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/feature", {
      params: type,
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const getFeatureListApi = async ({ tenantId, authToken, userId }) => {
//     try {
//         const { data } = await client().get(
//             endPoints.auth + '/saveupdate/Torcai?type=feature&action=list', {
//             headers: {
//                 common: {
//                     'torc_tenant': parseInt(tenantId),
//                     'torc_user': userId,
//                     'Authorization': `Bearer ${authToken}`
//                 }
//             }
//         }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const getFeatureListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/feature?action=list&type=featuredetail",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const addFeatureApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/saveupdate/Torcai?type=feature', payload
//             , {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addFeatureApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/feature?type=featuredetail",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const addFeatureAttributeApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
//     try {
//         const { data } = await client().post(
//             endPoints.auth + '/feature/Torcai', payload
//             , {
//                 params: addParams,
//                 headers: {
//                     common: {
//                         'torc_tenant': parseInt(tenantId),
//                         'torc_user': userId,
//                         'Authorization': `Bearer ${authToken}`
//                     }
//                 }
//             }
//         );
//         return data;
//     } catch (error) {
//         // get axios errors from error.response
//         console.log(error);
//         throw error;
//     }
// }

export const addFeatureAttributeApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(endPoints.auth + "/feature", payload, {
      params: addParams,
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          torc_user: userId,
          Authorization: `Bearer ${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const roleAccessPermissions = async ({
  tenantId,
  authToken,
  userId,
  userType = "byuser",
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/role?list=" + userType,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ---- * Audience * ----

// * Apr api *
export const getAprApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd.data + "/apr/list", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_user: userId,
          tai_token: `${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAprApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd.data + `/apr/${addParams}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAprEditApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/apr/get?", {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const aprDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  aprId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.atd.data + "/apr/download?id=" + aprId,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const getSegmentListApi = async ({ tenantId, authToken, userId }) => {
//   try {
//     const { data } = await client().get(endPoints.atd + "/data/segment?list=all", {
//       headers: {
//         common: {
//           tai_tenant: parseInt(tenantId),
//           tai_user: userId,
//           tai_token: `${authToken}`,
//         },
//       },
//     });
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };



export const getSegmentListApi = async ({ tenantId, authToken, userId, params, Addparams }) => {
  let a = '';
  if (params == 'custom') {
    a = `&type=custom`;

  } else if (params == 'unclassified') {
    a = `&type=unclassified`;
  }
  try {
    const { data } = await client().get(
      // endPoints.data + '/segment?list=all', 
      endPoints.atd + `/data/segment?list=all` + (params != " " ? a : ""),
      {
        params: Addparams,
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_user': userId,
            'tai_token': `${authToken}`
          }
        }
      });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}





export const getHierarchyListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.atd + "/data/hierarchy?list=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addHierarchyApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/data/hierarchy?addup=" + addParams,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteHierarchyApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.atd + "/data/hierarchy?delhierarchy=" + deleteId,
      {
        // params: deleteId,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const addSegmentApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/data/segment?addup=" + addParams,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDataPixelEditApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/audience/Torcai?", {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// DataCaptureApi
export const addDataCaptureApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
  try {
    const { data } = await client().post(
      endPoints.atd + '/data/audience/Torcai', payload, {
      params: addParams,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getDataCaptureApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/audience/Torcai", {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDataCaptureListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.atd + "/data/audience/Torcai?list=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteDataCaptureApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/audience/Torcai", {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getsegmentEditApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/segment?", {
      params: editId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// audiance Hierarchy

export const getAudhierarchyListApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/hierarchy?audhierarchylist=all",
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_user: userId,
            tai_token: `${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const downloadingConversionTagApi = async ({
  tenantId,
  authToken,
  userId,
  dwnldpxlsId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/audience/Torcai", {
      params: dwnldpxlsId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_user: userId,
          tai_token: `${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
// endPoints.atd + `/cat?action=list&type=AUD_PXL_MACROS

export const getAudiancePixelMicrosApi = async ({
  tenantId,
  authToken,
  userId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.atd + "/cat?action=list&type=AUD_PXL_MACROS",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// DataCaptureApi
export const checkTagAndPostbackuniqueApi = async ({
  tenantId,
  authToken,
  userId,
  checkParam,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/audience/Torcai", {
      params: checkParam,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

/* common api */
export const uploadScriptApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client({ multipart: true }).patch(
      "/upload-js",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getPinCodeListApi = async ({
  tenantId,
  authToken,
  userId,
  cncode,
  scode,
  ccode,
}) => {
  let cnscnccCode;
  if (cncode || scode || ccode) {
    cnscnccCode = { cncode, scode, ccode };
  }
  try {
    const { data } = await client().get(endPoints.geo + "?type=pincode", {
      params: cnscnccCode,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// reset password
export const forgotPasswordApi = async (authUser) => {
  try {
    const { data } = await client({ auth: true }).post(endPoints.auth + "/oauth/fp", "", {
      headers: {
        common: {
          auth_user: authUser,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const validateResetPasswordApi = async ({ rp }) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/oauth/ufp?rp=" + rp);
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// export const changePasswordApi = async ({ password, rp }) => {
//   // 'authentication/oauth/cp?password=' + password + '&rp=' + rp, '', {
//     try {
//       const { data } = await client({ auth: true }).post(
//         endPoints.auth +
//         "/oauth/cp?password=" +
//         encodeURIComponent(password) +
//         "&rp=" +
//         rp,
//         "",
//         {
//           // headers: {
//           //     common: {
//           //         'auth_user': authUser
//           //     }
//           // }
//         }
//       );
//       return data;
//     } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };

export const changePasswordApi = async ({ password, rp }) => {
  // 'authentication/oauth/cp?password=' + password + '&rp=' + rp, '', {
  try {
    const { data } = await client().post(
      endPoints.auth + '/oauth/v2/cp?data=' + password + '&rp=' + rp, '', {
      // headers: {
      //     common: {
      //         'auth_user': authUser
      //     }
      // }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

// * campaign screen site list *
export const getCampaignSiteApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.medialist + "?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_user: userId,
          tai_token: `${authToken}`,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// upload site file

export const uploadSiteFileApi = async ({ payload }) => {
  try {
    const { data } = await client({ multipart: true }).patch(
      `/upload-site`,
      payload,
      {}
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addCampaignSiteApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client().post(endPoints.medialist, payload, {
      params: addParams,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteCampaignSiteApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.medialist, {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignPerformanceReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  campaignPerformanceReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/campaignreport?action=Download",
      campaignPerformanceReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getBidderReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  bidderReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/bidderreport?action=Download",
      bidderReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getMediaPlanningDownloadReportApi = async ({
  tenantId,
  authToken,
  userId,
  mediaPlanningReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.bidder + "/mediaplanning?action=Download",
      mediaPlanningReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getMediaReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  mediaReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/mediareport?action=Download",
      mediaReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRevenueReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  revenueReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/billingreport?action=Download",
      revenueReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getQpsReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  qpsReportReqBody,
}) => {
  try {
    const { data } = await client().post(
      endPoints.ionReport + "/qps?action=Download",
      qpsReportReqBody,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignPixelListApi = async ({
  tenantId,
  authToken,
  userId,
  advertiserId,
}) => {
  try {
    const { data } = await client().get(
      endPoints.data + "/audience/Torcai?list=" + advertiserId,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteSegmentApi = async ({
  tenantId,
  authToken,
  userId,
  deleteId,
}) => {
  try {
    const { data } = await client().get(endPoints.atd + "/data/segment", {
      params: deleteId,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const editUpTenantApi = async (
  tenantId,
  authToken,
  userId,
  data,
  addParams,
  id,
  type
) => {
  console.log(data);
  try {
    // let isAdd = (addParams.action === "create") ? "auto" : id;
    const { x } = await client().post(
      `/map/tenant?${addParams.action}=account&id=${id}`,
      data,
      {
        // param: response,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: authToken,
          },
        },
      }
    );
    return x;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addUpTenantApi = async (
  tenantId,
  authToken,
  userId,
  response,
  payload,
  type
) => {
  try {
    // let isAdd = (addParams.action === "create") ? "auto" : id;
    const { data } = await client().post(
      `/map/tenant?addup=${type}&id=${response}`,
      payload,
      {
        // param: response,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const getAccountsListApi = async (tenantId, authToken, userId) => {
  try {
    const { data } = await client({ auth: true }).get(endPoints.auth + "/account?list=all", {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          Authorization: `Bearer ${authToken}`,
          torc_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const addAccountApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
  id,
}) => {
  try {
    let isAdd = addParams.action === "create" ? "auto" : id;
    const { data } = await client({ auth: true }).post(
      endPoints.auth + `/account?addup=${isAdd}`,
      payload,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editAccountApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + `/account?list=${editId}`,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const addPlatformApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  try {
    const { data } = await client({ auth: true }).post(
      endPoints.auth + "/platform",
      payload,
      {
        params: addParams,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const editPlatformApi = async ({
  tenantId,
  authToken,
  userId,
  editId,
}) => {
  try {
    // const { data } = await client().get(
    //     endPoints.auth + '/platform', {
    //     params: editId,
    //     headers: {
    //         common: {
    //             'torc_tenant': parseInt(tenantId),
    //             'torc_user': userId,
    //             'Authorization': `Bearer ${authToken}`
    //         }
    //     }
    // }
    // );
    let a = {
      responseCode: {
        msg: "platform updated successfully",
        status: "Success",
        code: 2006,
      },
    };
    return a;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getPlatformListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/platform?list=all&type=platform",
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getPlatformSingleListApi = async ({
  tenantId,
  authToken,
  userId,
  id,
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + "/platform?list=" + id,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




// *****************************Media Plan starts here screen aPI



export const getMediaPlanListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/mediaplan?action=list", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getAgeListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/cat?action=list&type=ageGroups", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCategoryApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/cat?action=list&type=category", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getSUbCategoryApi = async ({ tenantId, authToken, userId, cateID }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/cat?action=list&type=subCategory&id=${cateID}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postMediaPlanCreationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  console.log(payload, "api");

  try {
    const { data } = await client().post(
      endPoints.atd + "/mediaplan?action=create",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// postMediaPlanApi




// *****************************Media Plan ends here screen aPI





// ****************************   OPTIMIZER SCREEN STARTS HERE********************************

export const getOptimizerListApi = async ({ tenantId, authToken, userId, params = {}, payload = {} }) => {
  try {
    const { data } = await client().post("bekireco/reco/optimizer", payload, {
      params: params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getOptimizerListRecommendationApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get("/reco/optimizer?listcurrent=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getRecommendationApi = async ({ tenantId, authToken, userId, roID }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/optimizer?listcurrent=all&id=${roID}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postUpdateRecommendationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/optimizer?updateReco",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    // let data = {"responseCode":{"msg":"Recommendations Rejected Sucessfully","status":"Success","code":6004},"length":0}

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postDeleteRecommendationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/optimizer?updateReco&delete",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
































// ****************************   OPTIMIZER SCREEN ENDS HERE********************************





// ============== RO api implementation
export const getPrimaryGoalApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/cat?action=list&type=primaryGoal", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRoListApi = async ({ tenantId, authToken, userId, payload = {} }) => {
  try {
    const { data } = await client().post(endPoints.atd + "/ro?action=list", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRoMppedCampaignList = async ({ tenantId, authToken, userId, roID }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/ro?action=roCampList&id=${roID}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const downloadRoList = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.atd + `/ro?action=list&download`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const deleteMappedCampaignWithRo = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/ro?action=DeleteCampRo`, {
      params: params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postCampaignListNamesWithRo = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.atd + `/ro?action=listMappedCamps`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getCountUnmappedCampaign = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/unmapcamp?action=count`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postUpdateStatusRo = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.atd + `/ro?action=updateStatus`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// console.log("api", payload);
export const getSecondaryGoalApi = async ({ tenantId, authToken, primaryGoalID, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/cat?action=list&type=secondaryGoal&id=${primaryGoalID}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postMediaPlanApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/mediaplan?action=create",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
export const createRoApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  console.log("api", tenantId, userId);

  try {
    const { data } = await client().post(
      endPoints.atd + "/ro?action=create",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

//  ================== end ro api ==============>>>>>>> 




// ******************************** UNMAPPED CAMPAIGN API STARTS HERE ***************************


export const getUnmappedCampaignListApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.atd + "/unmapcamp?action=list", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postUnmappedCampaignListApi = async ({ tenantId, authToken, userId, payload }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().post(endPoints.atd + "/unmapcamp?action=list", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const createMapRoApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/unmapcamp?action=createandmapro",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const mapExistingRo = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/unmapcamp?action=mapwithro",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};














// ****************************************** UNMAPPED CAMPAIGN API ENDS HERE  ****************************888







export const getRoListNamesApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/ro?action=listnames", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getRoListByIdApi = async ({ tenantId, authToken, userId, roId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/ro?action=list&id=${roId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const updateRoApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {

  try {
    const { data } = await client().post(
      endPoints.atd + "/ro?action=update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


//  ================== end ro api ==============|||||||

// ================== campaign audience ====================
export const getGoogleAudienceList = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/campaign?action=listAudience&platform=google", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// 
export const getDv360AudienceList = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/campaign?action=listAudience&platform=dv360", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getFacebookAudienceList = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/campaign?action=listAudience&platform=facebook", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




// ================= campaign api implementaiton =================

export const createCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {

  try {
    const { data } = await client().post(
      endPoints.atd + "/campaign?action=createCampaign",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignListApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(endPoints.beki + `/campaign`, {
      params: params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const campaignListById = async ({ tenantId, authToken, userId, campaignId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/campaign?action=listCamp&id=${campaignId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// getCampaignList
export const postCampaignList = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.atd + "/campaign?action=listCamp", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const updateCampaignStatusApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.atd + endPoints.campaign + "?action=updateStatus", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// 
export const updateCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/campaign?action=updateCampaign",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};










// ************************* ADMIN MARGIN SCREEN STARTS HERE *************************************


export const getAdvertiserListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/adminMargin?action=listAdvertisers", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getAllCampaignListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/adminMargin?action=listCampaignDetails", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getAllListAdminMarginApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/adminMargin?action=list", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postCreationAdminMarginApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/adminMargin?action=create",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getListByIdAdminMarginApi = async ({ tenantId, authToken, userId, roId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/adminMargin?action=list&id=${roId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const postUpdatetionAdminMarginApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/adminMargin?action=update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const getPlaformWiseApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + '/adminMargin?action=platformWiseAdType', {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};








// *******************_______----------------------->>>> Margin Module  Screen API starts here *****************



export const getAllListMarginApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + "/margin?action=list", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postCreationMarginApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/margin?action=create",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getListByIdMarginApi = async ({ tenantId, authToken, userId, roId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/margin?action=list&id=${roId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const postUpdatetionMarginApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/margin?action=update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



//  csv downloadAPi***************************************



export const postDownloadCsvApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/campaign-performance?action=download",
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



// ==================>    Dashboard Second screen  CSV reports downlaod ===========================



export const postPerformanceReportDownloadCsvApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=${campaignId}&datewise=1&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postCreativeReportDownloadCsvApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/creative-performance?campaignId=${campaignId}&creativewise=1&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postGeoReportDownloadCsvApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/geo-performance?campaignId=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postDomainReportDownloadCsvApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/domain-performance?list=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// Age  Report function here 

export const ageDataReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/age-performance?list=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

//  Gender Report data function here

export const genderDataReportDownloadApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/gender-performance?list=${campaignId}&download`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postPerformanceReportApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId,
  id
}) => {

  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/campaign-performance?list=${campaignId}&datewise=${id}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const getMediaplanPdfApi = async ({ tenantId, authToken, userId, mediaplanName }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/mediaplan?action=status&name=${mediaplanName}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};






// ======================================PAYMENT API fUNCTIONS STATS HERE========================================>







// export const getAddPaymentRedirectUrl = async (amount, targetId, tenantId, userId, authToken, filterPspFromConfig) => {
//   try {
//     const url = `${endPoints.payment}/add/invoke?amount=${parseFloat(amount)}&pspid=${filterPspFromConfig}&mode=${targetId}`
//     const { data } = await client().get(
//       url,
//       {
//         headers: {
//           common: {
//             'tai_tenant': parseInt(tenantId),
//             'tai_token': authToken,
//             'tai_user': userId,
//           }
//         }
//       }
//     )
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// }
export const getAddPaymentRedirectUrl = async ({ tenantId, authToken, userId, amount, targetId, filterPspFromConfig, payload }) => {
  try {
    const { data } = await client().post(
      `${endPoints.payment}/add/invoke?amount=${parseFloat(amount)}&pspid=${filterPspFromConfig}&mode=${targetId}`, payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let a = { "responseCode": { "code": 1001, "status": "Success", "desc": "Tenant Details Updated" } }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


// Beki2.0 Redirect third party Function 

export const postAddPaymentRedirectUrl = async ({ tenantId, authToken, userId, amount, filterPspFromConfig, payload }) => {
  try {
    const { data } = await client().post(
      `${endPoints.payment}/add/invoke?amount=${parseFloat(amount)}&pspid=${filterPspFromConfig}`, payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let a = { "responseCode": { "code": 1001, "status": "Success", "desc": "Tenant Details Updated" } }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



export const getBillingHistoryData = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.payment + "/billing/history?GET=billingHistory", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getTenantDetailsApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.payment + "/billing/invoice?get=tenant", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



export const editTenantDetailsApi = async (tenantId, authToken, userId, payload) => {
  try {
    const { data } = await client().post(
      endPoints.payment + "/billing/invoice?addup=auto", payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let a = { "responseCode": { "code": 1001, "status": "Success", "desc": "Tenant Details Updated" } }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getInvoiceDetailsApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.payment + "/billing/invoice?get=invoicedetails", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getTentitiveInvoiceApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.payment + "/billing/invoice?get=currentdetails", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



// export const geBillingHistoryApi = async ({ tenantId, authToken, userId, payload }) => {
//   try {
//     const { data } = await client().post(
//       endPoints.payment + "/billing/history?GET=billingHistory", payload,
//       {
//       headers: {
//         common: {
//           'tai_tenant': parseInt(tenantId),
//           'tai_token': authToken,
//           'tai_user': userId,
//         }
//       }
//     }
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// }


export const geBillingHistoryApi = async ({ tenantId, authToken, userId, payload }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + "/billing/history?GET=billingHistory",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const PostCreditAmmountApi = async ({ tenantId, authToken, userId, payload, ammount }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + `/add/invoke?amount=${ammount}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getInvoiceDetailListAllApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.payment + "/v2/billing/invoice/list?list=all", payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}




export const getTenantInvoiceDetailApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.payment + "/billing/invoice?get=tenant", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getCurrentMonthInvoiceListApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.payment + "/v2/billing/invoice/list?list=current", payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        },
        "Content-Type": "application/json"
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



export const getInfomoSeatGoogleApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(apiBaseUrl + `/adwords/signinads?platform=GoogleAdwords&action=infomoSeat`, {
      params: params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getInfomoSeatFacebookApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(apiBaseUrl + `/fb/user/accounts?action=infomoSeat`, {
      params: params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getInfomoSeatTiktokApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(endPoints.tiktok + `/login/infomoSeat`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postUpdateTenantDetailApi = async ({ tenantId, authToken, userId, payload }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + "/billing/invoice?addup=auto",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getSubscriptionListAllApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/plan?list=all", payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



export const getSubscriptionListManageServiceTrailApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/plan?list=trial", payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getSularCountryListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.tai + "/geo/torcai?type=country&srch=",
      //  'https://testbenchv2.torcai.com/tai/solr/geo/torcai?type=country&srch=',
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getListByIDSubscriptionPlanApi = async ({ tenantId, authToken, userId, id }) => {
  try {
    const { data } = await client().get(
      endPoints.subscription + `/plan?listAll&id=${id}`,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}




export const getSubscribeTrialpi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.subscription + "/plan?list=trial", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}



export const postRecchageSubscribeApi = async ({ tenantId, authToken, userId, payload }) => {

  try {
    const { data } = await client().post(
      endPoints.subscription + "/subscribe",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getSubscriptionHistoryListAllApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/subdetails?list=all", payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        },
        "Content-Type": "application/json"
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getCurrentSubscriptionPlanApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/subdetails?list=current", payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}




export const getSubscriptionCurrentApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/subdetails?list=current", payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getSetAlertsListAllpi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.payment + "/alert/fetch?list=all", payload, {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        },
        "Content-Type": "application/json"
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const postCreateSetAlertsApi = async ({ tenantId, authToken, userId, payload }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + "/alert/update?addup=auto",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postUpdateSetAlertsApi = async ({ tenantId, authToken, userId, payload, headerID }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + `/alert/update?addup=${headerID}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getPaymentRelatedAccessApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.subscription + "/subdetails?list=current", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getPaymentPrefrenceApi = async ({ tenantId, authToken, userId, payload, }) => {

  try {
    const { data } = await client().post(
      endPoints.payment + `/fetch/pref`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};






//  ======================================PAYMENT API'S FUNCTIONS ENDS HERE====================================>






export const getStatusPdfCheckApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    // const { data } = await client().get(endPoints.atd + "/mediaplan?action=status&name=Test*Plan*1", {
    const { data } = await client().get(endPoints.atd + "/mediaplan?action=status&name=Test*Plan*1", {

      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ==== google login api's ===========
export const getGoogleUrlApi = async ({ tenantId, authToken, userId, callbackUrl }) => {
  try {
    const { data } = await client().get(apiBaseUrl + `/adwords/signinads/?url&platform=GoogleAdwords&callbackurl=${callbackUrl}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postMapDefaultSeatsApi = async ({ tenantId, authToken, userId, params = {}, payload = {} }) => {
  try {
    const { data } = await client({ auth: true }).post(endPoints.beki + "/seat/config/map",
      payload,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postUserMappedSeatsApi = async ({ tenantId, authToken, userId, params = {}, payload = {} }) => {
  try {
    const { data } = await client({ auth: true }).post(endPoints.beki + "/seat/config/thirdparty",
      payload,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postThirdPartyLoginUrlApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/platform/${params.platform}/login`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postThirdPartyLoginVerificationApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/platform/${params.platform}/login/verify`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postThirdPartyLoginPartnersApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/platform/${params.platform}/partners`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postAddThirdPartySeatApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/seat/config/thirdparty`, payload, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postCampaignSyncListApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(endPoints.beki + `/platform/${params.platform}/campaign/list`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postCampaignSyncApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    let action = {};
    if (params.hasOwnProperty('action')) {
      action = { action: params.action };
    }
    const { data } = await client().post(endPoints.beki + `/sync/campaign/${params.platform}`, payload, {
      params: action,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getGoogleUserInformationApi = async ({ tenantId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(apiBaseUrl + `/adwords/campsync/?platform=GoogleAdwords&camplist`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postGoogleVerificationApi = async ({ tenantId, authToken, userId, payload }) => {

  try {
    const { data } = await client().post(
      apiBaseUrl + `/adwords/signinads/?verfication&platform=GoogleAdwords`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postTiktokVerificationApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client().post(
      endPoints.tiktok + `/login/accounts?action=list`, {},
      {
        params: params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postTiktokCampaignSyncApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.tiktok + `/login/campaigns?action=sync`, payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postTiktokCampaignApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.tiktok + `/login/campaigns?action=list`, payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postTiktokResyncCampaignApi = async ({ tenantId, authToken, userId, accountId }) => {
  try {
    const { data } = await client().post(
      endPoints.tiktok + `/login/campaigns?action=list&refetch&account_id=${accountId}`, {},
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getTiktokRedirectUrlApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.tiktok + `/login/url`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
        "Content-Type": "application/json"
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// =================================  DATA CONFIG   STARTS HERE ===============================>>>>>>>>>
export const getDataConfigValuesListApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client().get(endPoints.beki + `/dataconfig`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
        "Content-Type": "application/json"
      },
      params,
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDataConfigListApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client().get(endPoints.beki + `/dataconfigv2/variable`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
        "Content-Type": "application/json"
      },
      params,
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postDataConfigVariableApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(
      endPoints.beki + `/dataconfig`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
        params,
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postDataConfigV2VariableApi = async ({ tenantId, authToken, userId, params = {}, payload = {} }) => {
  try {
    const { data } = await client().post(
      endPoints.beki + `/dataconfigv2/variable`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
          "Content-Type": "application/json"
        },
        params,
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postGoogleAccountApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/adwords/signinads/?platform=GoogleAdwords&masterid`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          }, "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postDv360AccountApi = async ({
  tenantId,
  userId,
  authToken,
  payload,
}) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + "/dv360/auth?platform=DV360&partnerId",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getListDspPlatformApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.atd + "/data-config/platform?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};







export const postDspPlatfornCreationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/data-config/platform?addup=auto",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getListByIdDspPlatformApi = async ({ tenantId, authToken, userId, platformId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.atd + `/data-config/platform?list=${platformId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postDspPlatfornUpdateApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  platformId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + `/data-config/platform?addup=${platformId}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};






export const getVariableListApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + "/dataconfig?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },

      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};




export const postVariableCreationApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + "/data-config/variables?addup=auto",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getListByIdVariableApi = async ({ tenantId, authToken, userId, platformId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + `/dataconfigv2/variable?list=${platformId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postVariableUpdateApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  platformId
}) => {
  try {
    const { data } = await client().post(
      endPoints.atd + `/data-config/variables?addup=${platformId}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};





// downlaod CSV For AUDInce Tab




export const audienceHierarchyDownloadCSVApi = async ({ tenantId, authToken, userId, hierarchy }) => {
  try {
    console.log("hierarchy", hierarchy)
    const { data } = await client().get(
      endPoints.atd + `/data/segment?download=${hierarchy}`,
      {
        // params: hierarchy,
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}





export const postCampaignApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/adwords/signinads/?platform=GoogleAdwords&synccamp`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postSyncCampaignApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/adwords/campsync/?platform=GoogleAdwords&campsync`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postSyncCampaignDV360Api = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + "/dv360/sync/data?campsync",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postSyncCampaignIonApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/ion-atd/signin/campSync`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



// =========== facebook signin api implementation ===========


export const getFbUserInfoApi = async ({ accessToken }) => {
  console.log("api accesstoken ", accessToken);

  try {
    const { data } = await client().get(
      apiBaseUrl + `/fb/user/accounts?action=list&token=${accessToken}`, {
      headers: {
        "Content-Type": "application/json"
      }
    }
    );

    // const { data } = await client().get(
    //   `https://stageatdv2.torcai.com/fb/user/accounts?action=list&token=${accessToken}`, {
    //   headers: {
    //     "Content-Type": "application/json"
    //   }
    // }
    // )
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const campaignDetailsApi = async ({ tenantId, userId, payload }) => {

  try {
    const { data } = await client().post(
      apiBaseUrl + `/fb/user/campaigns?action=list`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_user: userId,
        },
      },
    }
    );
    // const { data } = await client().post(
    //   `https://stageatdv2.torcai.com/fb/user/campaigns?action=list`, payload, {
    //   headers: {
    //     common: {
    //       tai_tenant: parseInt(tenantId),
    //       tai_user: userId,
    //     },
    //   },
    // }
    // );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const facebookSyncCampaignApi = async ({ tenantId, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/fb/user/campaigns?action=sync`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_user: userId,
        },
      },
    }
    );

    // const { data } = await client().post(
    //   `https://stageatdv2.torcai.com/fb/user/campaigns?action=sync`, payload, {
    //   headers: {
    //     common: {
    //       tai_tenant: parseInt(tenantId),
    //       tai_user: userId,
    //     },
    //   },
    // }
    // );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const facebookCampaignPagesApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(`/fb/data/pages`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const facebookCampaignNamesApi = async ({ tenantId, authToken, userId, accountId }) => {
  try {
    const { data } = await client().get(`fb/user/campaigns?account_id=${accountId}&refetch=true&action=list`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


// dv360 signin

export const getDv360UrlApi = async ({ callbackUrl }) => {

  try {
    const { data } = await client().get(apiBaseUrl + `/dv360/auth?url&platform=DV360&callbackurl=${callbackUrl}`, {
      headers: {
        "Content-Type": "application/json"
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postDV360VerificationApi = async ({
  tenantId,
  userId,
  authToken,
  payload,
}) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + "/dv360/auth?verfication&platform=DV360",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postDv360CampaignApi = async ({
  tenantId,
  userId,
  authToken,
  payload,
}) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + "/dv360/auth?platform=DV360&synccamp",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getGamUrlApi = async () => {
  try {
    const { data } = await client().get(apiBaseUrl + `/gam/auth?platform=GAM&url`, {
      headers: {
        "Content-Type": "application/json"
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postGamVerificationApi = async ({
  payload
}) => {

  try {
    const { data } = await client().post(
      apiBaseUrl + `/gam/auth?platform=GAM&verfication`,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postGamCampaignApi = async ({
  payload
}) => {

  try {
    const { data } = await client().post(
      apiBaseUrl + `/gam/auth?platform=GAM&order`,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// 
export const postGamSyncCampaignApi = async ({
  payload
}) => {

  try {
    const { data } = await client().post(
      apiBaseUrl + `/gam/auth?platform=GAM&syncOrder`,
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// 
export const getTiktokLocationApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(
      apiBaseUrl + `/tiktok/masterdata?action=geo`, {
      params: params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        },
      },
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getTikTokCampaignNamesApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(apiBaseUrl + `/tiktok/createcampaign?action=campaignname`, payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getTikTokAudienceApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.atd + `/campaign?action=listAudience&platform=tiktok`,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getTikTokFormIdApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(apiBaseUrl + `/tiktok/createcampaign?action=formid`, payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

// 
export const getGeoLocationApi = async ({ tenantId, authToken, userId, query }) => {
  try {
    const { data } = await client().get(
      endPoints.atd + `/geo?list=all&srch=${query}`,
      {
        // params: hierarchy,
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getGeoLocationApiFacebook = async ({ tenantId, authToken, userId, query }) => {
  try {
    const { data } = await client().get(`${query}`,
      {
        // params: hierarchy,
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getFbResyncApi = async ({ tenantId, userId, authToken, accountId }) => {
  try {
    const { data } = await client().get(apiBaseUrl + `/fb/user/campaigns?action=list&refetch=true&account_id=${accountId}`,
      {
        // params: hierarchy,
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    //   const { data } = await client().get(`https://stageatdv2.torcai.com/fb/user/campaigns?action=list&refetch=true&account_id=${accountId}`,
    //   {
    //     // params: hierarchy,
    //     headers: {
    //       common: {
    //         'tai_tenant': parseInt(tenantId),
    //         'tai_token': authToken,
    //         'tai_user': userId,
    //       }
    //     }
    //   }
    // );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const checkDuplicateNameApi = async ({ tenantId, authToken, userId, value }) => {
  try {
    const { data } = await client().get(
      endPoints.atd + endPoints.campaign + `?action=checkCampaignName&campaignName=${value}`,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
    // return {"responseCode":{"msg":"Campaign name already exists","status":"Success","code":5001},"length":0};

  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const checkDuplicateGoogleCampaignApi = async (tenantId, authToken, userId, customerId) => {
  try {
    const { data } = await client().post(
      `/adwords` + endPoints.campaign + `?action=namelist`,
      customerId,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}
// return {"responseCode":{"msg":"Google Campaign Name List","status":"Success","code":5062},"response":['Campaign 1', 'Campaign 2', 'Campaign 3']};

export const getFacebookAccountApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(
      endPoints.fb + "/data/accounts", {
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const deleteAccountsApi = async ({ tenantId, authToken, userId, accountId }) => {
  try {
    const { data } = await client().get(
      endPoints.atd + `/advertiser?action=delete&accountId=${accountId}`,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      });
    return data;
    // return {"responseCode":{"msg":"Account deleted Successfully","status":"Success","code":4036},"length":0};

  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const DV360CampaignNamesApi = async ({ tenantId, authToken, userId, accountId }) => {
  try {
    const { data } = await client().get(`dv360/name?advertiserId=${accountId}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getGenrateAccountIdDV360Api = async ({ tenantId, authToken, userId, payload }) => {
  console.log(payload, "Api")

  try {
    const { data } = await client().post(`dv360/infomoseat?action=useinfomo`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}




// export const getGenrateAccountIdDV360Api = async ({
//   tenantId,
//   authToken,
//   userId,
//   payload,
// }) => {
//   try {
//     const { data } = await client().post(
//        `/creative-performance?campaignId=${campaignId}&creativewise=1`,
//       payload,
//       {
//         // params: addParams,
//         headers: {
//           common: {
//             tai_tenant: parseInt(tenantId),
//             tai_token: authToken,
//             tai_user: userId,
//           },
//         },
//       }
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// };

// Campaign > Custom

export const getCampaignCustomApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.atd + "/campaign?action=custom", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// postCountryMapAction
export const postCountryMapApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  country
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/geo-performance?list=${country.toLowerCase()}`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// Fee setting API function starts here



export const getAdvertiserAndCampaignFilterListApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + "/fee?list=advcamp", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getFeeSettingsFilterListApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + "/margins/filter", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postGetbyIdFeeSettingApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.beki + `/margins/campaign/config?list=all`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postFilterFeeSettingApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.beki + `/fee?list=stratergy`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getFeeSettingListAllApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + "/margins/campaign/config?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getListbyIdFeeSettingApi = async ({ tenantId, authToken, userId, id }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(endPoints.beki + `/fee?list=stratergy&id=${id}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const postUpdateFeeSettingApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.beki + "/margins/campaign/config?addup=update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};








// Subscription plan mgr Screen Action here

export const postListAllSubscriptionPlanMgrApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/plan?listAll",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postAddSubscriptionPlanManagerApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/plan?add",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postUpdateSubscriptionPlanManagerApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + "/plan?update",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// world map



export const postWorldMapApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + "/geo-performance?list=all",
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postWorldGeoCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  campaignId,
  country
}) => {
  try {
    const { data } = await client().post(
      endPoints.atdDashboard + `/geo-performance?campaignId=${campaignId}&${country}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getIonCampaignNamesApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(apiBaseUrl + `/report-atd/campaign?action=checkCampaignNamePlatform&platform=ion`, payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postIonCampaignApi = async ({ tenantId, authToken, userId, payload }) => {
  console.log("postIonCampaignApi", payload);
  try {
    const { data } = await client().post(
      apiBaseUrl + `/ion-atd/signin/syncAcc`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "Data Fetched",
    //     "status": "Success",
    //     "code": 7005
    //   },
    //   "length": 0,
    //   "response": {
    //     "tenantName": "ATD_TEST",
    //     "tenantId": 426,
    //     "username": "goutam@torcai.com",
    //     "password": "d1ff0f7502e3cc0acf22473d98002ebe361ad651cf3dcd63431181c9b86bf01d",
    //     "campList": [
    //       {
    //         "campName": "NestleFeb22",
    //         "campId": 280,
    //         "contentType": 0,
    //         "status": 0,
    //         "sDate": "Feb 11, 2022 00:00:00",
    //         "eDate": "Feb 11, 2023 23:59:00",
    //         "isExist": 0
    //       }
    //     ],
    //     "advId": 367,
    //     "infoId": 346,
    //     "accessToken": "35554545420b4f80bd75d3520c2c618b",
    //     "userId": 19,
    //     "timeStamp": "1689578414963",
    //     "tenantToken": "A0D4D0FD0AD092129DD8B4D9DDDB1E28"
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAudHierarchyListApi = async ({ tenantId, authToken, userId, customerId }) => {
  try {
    const { data } = await client().get(apiBaseUrl + `/ion-atd/audience?audhierarchylist=all&customer=${customerId}`,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          }
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getIonLocationApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(
      apiBaseUrl + `/ion-atd/geo?list=all&srch=${params.srch}`, {
      // params:params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        },
      },
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getCampaignCategoryApi = async ({ tenantId, authToken, userId }) => {
  try {
    // const { data } = await client().get(endPoints.auth + '/config/Torcai?type=CAMPAIGN_CATEGORY_TYPE',
    const { data } = await client().get('/auth/v3/config?action=list&type=CAMPAIGN_CATEGORY_TYPE',
      {
        headers: {
          common: {
            'torc_tenant': parseInt(tenantId),
            'torc_user': userId,
            'Authorization': `Bearer ${authToken}`
          }
        }
      });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getCampaignSubCategoryApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  addParams,
}) => {
  // try {
  //   const { data } = await client({ auth: true }).get(
  //     endPoints.auth +
  //     `/config?action=list&type=${payload.list.join(",")}&value=child`,
  //     {
  //       params: addParams,
  //       headers: {
  //         common: {
  //           torc_tenant: parseInt(tenantId),
  //           torc_user: userId,
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       },
  //     }
  //   );
  //   let arr = [];
  //   if (payload.list.length > 1) {
  //     Object.keys(data.responseList[0]).forEach((key) => {
  //       arr = [
  //         ...arr,
  //         ...data.responseList[0][key].map((item) => ({
  //           ...item,
  //           categoryId: key,
  //         })),
  //       ];
  //     });
  //     data.responseList = arr;
  //   }
  //   return data;
  try {
    if (payload.list.length == 1) {
      payload.list.push(-1)
    }
    const { data } = await client().get(
      endPoints.auth + `/config?action=list&type=${payload.list.join(',')}&value=child`, {
      params: addParams,
      headers: {
        common: {
          'torc_tenant': parseInt(tenantId),
          'torc_user': userId,
          'Authorization': `Bearer ${authToken}`
        }
      }
    }
    );
    let arr = [];
    if (payload.list.length > 1) {
      Object.keys(data.responseList[0]).forEach(key => {
        arr = [...arr, ...data.responseList[0][key].map((item) => ({ ...item, categoryId: key }))]
      })
      data.responseList = arr;
    }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const updateIonCampaignApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(`/ion-atd/campaign?status=${payload.status}`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getProfileListAllApi = async ({ tenantId, authToken, userId, params = {} }) => {
  try {
    const { data } = await client().get(endPoints.beki + "/profile?action=profile", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
      params,
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getProfileListAgencyApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.beki + "/profile?list=agency", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      }
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postPaymentCreditApi = async ({
  tenantId,
  authToken,
  userId,
  newTeanantId,
  Ammount,
  pspListID

}) => {
  try {
    const { data } = await client().post(
      endPoints.payment + `/add/credit?amount=${Ammount}&pspid=${pspListID}`,
      newTeanantId,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// ************Country and currency related API stats here*********************


export const getAllCurrencyApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.auth + "/config?action=list&type=CURRENCY", {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          Authorization: `Bearer ${authToken}`,
          torc_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getAllCountryApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(endPoints.auth + "/config?action=list&type=Country-Currency", {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          Authorization: `Bearer ${authToken}`,
          torc_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getFilterCurrencyApi = async ({ tenantId, authToken, userId, countryID }) => {
  try {
    const { data } = await client().get(endPoints.auth + `/config?action=list&type=${countryID},-1&value=child`, {
      headers: {
        common: {
          torc_tenant: parseInt(tenantId),
          Authorization: `Bearer ${authToken}`,
          torc_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};



//  sign-up
export const getSignupAllCurrencyApi = async () => {
  try {
    const { data } = await client().get(endPoints.auth + "/self-register/country?type=CURRENCY", {
      // headers: {
      //   common: {
      //     torc_tenant: parseInt(tenantId),
      //     Authorization: `Bearer ${authToken}`,
      //     torc_user: userId,
      //   },
      // },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const getSignupAllCountryApi = async () => {
  try {
    const { data } = await client().get(endPoints.auth + "/self-register/country?type=Country-Currency", {
      // headers: {
      //   common: {
      //     torc_tenant: parseInt(tenantId),
      //     Authorization: `Bearer ${authToken}`,
      //     torc_user: userId,
      //   },
      // },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSignupAllCountryTimeZone = async () => {
  try {
    const { data } = await client().get(endPoints.auth + "/self-register/country?type=COUNTRY_TIMEZONE", {
      // headers: {
      //   common: {
      //     torc_tenant: parseInt(tenantId),
      //     Authorization: `Bearer ${authToken}`,
      //     torc_user: userId,
      //   },
      // },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const getSignupFilterCurrencyApi = async ({ countryID }) => {
  try {
    const { data } = await client().get(endPoints.auth + `/self-register/country?type=${countryID},-1&value=child`, {
      // headers: {
      //   common: {
      //     torc_tenant: parseInt(tenantId),
      //     Authorization: `Bearer ${authToken}`,
      //     torc_user: userId,
      //   },
      // },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const postProfileBalanceApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  amount,
  pspID
}) => {
  try {
    const { data } = await client().post(
      endPoints.payment + `/add/profile/credit?amount=${amount}&pspid=${pspID}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postProfileDebitBalanceApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
  amount,
  pspID
}) => {
  try {
    const { data } = await client().post(
      endPoints.payment + `/add/profile/debit?amount=${amount}&pspid=${pspID}`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postAllTenantsFetchBalanceApi = async ({
  tenantId,
  authToken,
  userId,
  params,
  payload
}) => {
  try {
    const { data } = await client().post(
      endPoints.payment + `/fetch/balance`,
      payload,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};






// ************Country and currency related API Ends here*********************




export const postBalanceValueApi = async ({
  tenantId,
  authToken,
  userId,
  payload
}) => {
  try {
    const { data } = await client().post(
      endPoints.payment + `/fetch/balance`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postSubscribeApi = async ({
  tenantId,
  authToken,
  userId,
  payload
}) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + `/subscribe`,
      payload,
      {
        // params: addParams,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


// Don't touch this


export const getPlanListApi = async ({ tenantId, authToken, userId, payload, addParams }) => {
  try {
    const { data } = await client().post(
      endPoints.subscription + `/plan?list=${addParams.action}`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postContactSalesApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/subscription/plan?addup=auto&type=custom`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    // let data = {"responseCode":{"msg":"Custom Plan Request Submitted Successfully","status":"Success","code":3007}}
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const supportApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(
      apiBaseUrl + `/auth/v3/support?addup=auto`,
      payload,
      {
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            Authorization: `Bearer ${authToken}`,
            torc_user: userId,
          },
          "Content-Type": "application/json"
        },
      }
    );
    // let data = {"responseCode":{"msg":"Custom Plan Request Submitted Successfully","status":"Success","code":3007}}
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getLanguageListApi = async ({ tenantId, authToken, userId }) => {
  try {
    // const { data } = await client().get(endPoints.auth + '/config/Torcai?type=CAMPAIGN_CATEGORY_TYPE',
    const { data } = await client().get('report-atd/mediaplan?action=language',
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        },
      });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


//----BEKI 2.0


// getCampaignList
export const postCampaignListAll = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign?list=all", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "List Fetched Successfully",
    //     "status": "Success",
    //     "code": 4001
    //   },
    //   "length": 0,
    //   "response": [
    //     {
    //       "campaignId": 123,
    //       "campaignName": "Test",
    //       "platforms": 2,
    //       "advertiser": "Demo",
    //       "budget": 1001.90,
    //       "startDate": "2023-10-25",
    //       "endDate": "2023-10-30",
    //       "status": 0,
    //       "recos": 4,
    //       "campaigns": [
    //         {
    //           "campaignName": "Test-Search",
    //           "campaignId": 1,
    //           "platform": 1,
    //           "type": "2",
    //           "budget": 900.90,
    //           "startDate": "2023-10-25",
    //           "endDate": "2023-10-29",
    //           "status": 0,
    //           "recos": 2
    //         },
    //         {
    //           "campaignName": "Test-Video",
    //           "campaignId": 2,
    //           "platform": 2,
    //           "type": "1",
    //           "budget": 100.00,
    //           "startDate": "2023-10-26",
    //           "endDate": "2023-10-30",
    //           "status": 0,
    //           "recos": 2
    //         }
    //       ]
    //     },
    //     {
    //       "campaignId": 124,
    //       "campaignName": "Test",
    //       "platforms": 2,
    //       "advertiser": "Demo",
    //       "budget": 1001.90,
    //       "startDate": "2023-10-25",
    //       "endDate": "2023-10-30",
    //       "status": 1,
    //       "recos": 4,
    //       "campaigns": [
    //         {
    //           "campaignName": "Test-Search",
    //           "campaignId": 1,
    //           "platform": 1,
    //           "type": "2",
    //           "budget": 900.90,
    //           "startDate": "2023-10-25",
    //           "endDate": "2023-10-29",
    //           "status": 0,
    //           "recos": 2
    //         },
    //         {
    //           "campaignName": "Test-Video",
    //           "campaignId": 2,
    //           "platform": 2,
    //           "type": "0",
    //           "budget": 100.00,
    //           "startDate": "2023-10-26",
    //           "endDate": "2023-10-30",
    //           "status": 0,
    //           "recos": 2
    //         }
    //       ]
    //     }
    //   ]
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


//Campaign Filter

export const getCampaignFilterApi = async ({ tenantId, authToken, userId }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get("/beki/campaign?list=filter", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "Filter List Fetched Successfully",
    //     "status": "Success",
    //     "code": ""
    //   },
    //   "length": 0,
    //   "response": {
    //     "advertiserId": [
    //       {
    //         "key": 260,
    //         "value": "anchor"
    //       }
    //     ],
    //     "bekiCampaign": [
    //       {
    //         "key": "1",
    //         "value": "abc1"
    //       }
    //     ],
    //     "platformCampaign": [
    //       {
    //         "key": "1",
    //         "value": "abc2"
    //       },
    //       {
    //         "key": "2",
    //         "value": "abc3"
    //       }
    //     ],
    //     "status": [
    //       {
    //         "key": "0",
    //         "value": "inactive"
    //       },
    //       {
    //         "key": "1",
    //         "value": "active"
    //       },
    //       {
    //         "key": "2",
    //         "value": "draft"
    //       }
    //     ]
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postCampaignFilterApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign?list=allfilter", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "List Fetched Successfully",
    //     "status": "Success",
    //     "code": 4001
    //   },
    //   "length": 0,
    //   "response": [
    //     {
    //       "campaignId": 123,
    //       "campaignName": "FilterTest",
    //       "platforms": 2,
    //       "advertiser": "Demo",
    //       "budget": 1001.90,
    //       "startDate": "2023-10-25",
    //       "endDate": "2023-10-30",
    //       "status": 0,
    //       "recos": 4,
    //       "campaigns": [
    //         {
    //           "campaignName": "FilterTest-Search",
    //           "campaignId": 1,
    //           "platform": 1,
    //           "type": "2",
    //           "budget": 900.90,
    //           "startDate": "2023-10-25",
    //           "endDate": "2023-10-29",
    //           "status": 0,
    //           "recos": 2
    //         },
    //         {
    //           "campaignName": "FilterTest-Video",
    //           "campaignId": 2,
    //           "platform": 2,
    //           "type": "1",
    //           "budget": 100.00,
    //           "startDate": "2023-10-26",
    //           "endDate": "2023-10-30",
    //           "status": 0,
    //           "recos": 2
    //         }
    //       ]
    //     },
    //     {
    //       "campaignId": 124,
    //       "campaignName": "FilterTest2",
    //       "platforms": 2,
    //       "advertiser": "Demo",
    //       "budget": 1001.90,
    //       "startDate": "2023-10-25",
    //       "endDate": "2023-10-30",
    //       "status": 1,
    //       "recos": 4,
    //       "campaigns": [
    //         {
    //           "campaignName": "FilterTest2-Search",
    //           "campaignId": 1,
    //           "platform": 1,
    //           "type": "2",
    //           "budget": 900.90,
    //           "startDate": "2023-10-25",
    //           "endDate": "2023-10-29",
    //           "status": 0,
    //           "recos": 2
    //         },
    //         {
    //           "campaignName": "FilterTest2-Video",
    //           "campaignId": 2,
    //           "platform": 2,
    //           "type": "0",
    //           "budget": 100.00,
    //           "startDate": "2023-10-26",
    //           "endDate": "2023-10-30",
    //           "status": 0,
    //           "recos": 2
    //         }
    //       ]
    //     }
    //   ]
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postCampaignStatusApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign?action=status", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    //  let data = {"length":0,"response":{"msg":"Campaign Status has been successfully updated","status":"Success","code":100}}


    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postBasicDetailsSubmitApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign", payload, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "length": 0,
    //   "responseObj": {
    //     "msg": "Campaign Basic Details has been successfully updated",
    //     "status": "Success",
    //     "code": 100
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getDataConfigApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().post("/beki/dataconfig?list=all", {}, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postCustomDetailsApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign?plan=auto", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "Mandate's Plan Insertion Done Successfully",
    //     "status": "Success",
    //     "code": 206
    //   },
    //   "length": 0,
    //   "responseObj": {
    //     "ads": [
    //       {
    //         "id": 1,
    //         "stratgies": [
    //           {
    //             "id": 1,
    //             "type": 2
    //           }
    //         ]
    //       },
    //       {
    //         "id": 2,
    //         "stratgies": [
    //           {
    //             "id": 2,
    //             "type": 0
    //           }
    //         ]
    //       }
    //     ],
    //     "meta": [
    //       {
    //         "id": 3,
    //         "stratgies": [
    //           {
    //             "id": 3,
    //             "type": 1
    //           },
    //           {
    //             "id": 4,
    //             "type": 0
    //           }
    //         ]
    //       }
    //     ],
    //     "dv360": [
    //       {
    //         "id": 4,
    //         "stratgies": [
    //           {
    //             "id": 5,
    //             "type": 1
    //           },
    //           {
    //             "id": 6,
    //             "type": 0
    //           }
    //         ]
    //       }
    //     ],
    //     "ion": [
    //       {
    //         "id": 5,
    //         "stratgies": [
    //           {
    //             "id": 7,
    //             "type": 1
    //           }
    //         ]
    //       },
    //       {
    //         "id": 6,
    //         "stratgies": [
    //           {
    //             "id": 8,
    //             "type": 0
    //           }
    //         ]
    //       }
    //     ],
    //     "tiktok": [
    //       {
    //         "id": 7,
    //         "stratgies": [
    //           {
    //             "id": 9,
    //             "type": 1
    //           }
    //         ]
    //       }
    //     ]
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const campaignSearchApi = async ({ tenantId, authToken, userId, payload, searchParams }) => {
  try {
    const { data } = await client().post(
      `/beki/campaign?list=all&srch=${searchParams}`,
      payload,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        }
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getLanguageApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`beki/targeting?language=Language&platform=${params.platform}`,
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
          "Content-Type": "application/json"
        },
      });
    // let data = {
    //   "responseCode": { "msg": "Language List Fetched SuccessFully", "status": "Success", "code": 211 },"response": [{ "id": "ar", "value": "Arabic" }, { "id": "as", "value": "Assamese" }, { "id": "bgc", "value": "Haryanvi" }, { "id": "bh", "value": "Bihari" }, { "id": "bn", "value": "Bengali" }, { "id": "cs", "value": "Czech" }, { "id": "de", "value": "German" }, { "id": "el", "value": "Greek" }, { "id": "en", "value": "English" }, { "id": "es", "value": "Spanish" }, { "id": "fi", "value": "Finnish" }, { "id": "fr", "value": "French" }, { "id": "gu", "value": "Gujarati" }, { "id": "he", "value": "Hebrew" }, { "id": "hi", "value": "Hindi" }, { "id": "hu", "value": "Hungarian" }, { "id": "id", "value": "Indonesian" }, { "id": "it", "value": "Italian" }, { "id": "ja", "value": "Japanese" }, { "id": "km", "value": "Khmer" }, { "id": "kn", "value": "Kannada" }, { "id": "ko", "value": "Korean" }, { "id": "ml", "value": "Malayalam" }, { "id": "mr", "value": "Marathi" }, { "id": "ms", "value": "Malay" }, { "id": "nl", "value": "Dutch" }, { "id": "or", "value": "Oriya" }, { "id": "pa", "value": "Punjabi" }, { "id": "pl", "value": "Polish" }, { "id": "pt", "value": "Portuguese" }, { "id": "raj", "value": "Rajasthani" }, { "id": "ro", "value": "Romanian" }, { "id": "ru", "value": "Russian" }, { "id": "sv", "value": "Swedish" }, { "id": "ta", "value": "Tamil" }, { "id": "te", "value": "Telugu" }, { "id": "th", "value": "Thai" }, { "id": "tr", "value": "Turkish" }, { "id": "uk", "value": "Ukrainian" }, { "id": "vi", "value": "Vietnamese" }, { "id": "zh-Hant", "value": "Chinese (traditional)" }], "length": 0
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getLocationApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`/beki/targeting?location=${params.location}&platform=${params.platform}`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {"responseCode":{"msg":"Location List Fetched SuccessFully","status":"Success","code":212},"length":0,"responseObj":[{"critId":"20456","id":"575","name":"Delhi","type":"Union Territory","parent":"2356"},{"critId":"1013726","id":"13168","name":"Delhi","type":"City","parent":"21137"},{"critId":"1015742","id":"15183","name":"Delhi","type":"City","parent":"21145"},{"critId":"1022856","id":"22295","name":"Delhi","type":"City","parent":"21167"},{"critId":"9051816","id":"76704","name":"Delhi","type":"City","parent":"21168"},{"critId":"9075215","id":"100085","name":"Delhi","type":"City","parent":"20456"},{"critId":"1007751","id":"8159","name":"New Delhi","type":"City","parent":"20456"},{"critId":"9051817","id":"76705","name":"Delhi charter Township","type":"City","parent":"21155"}]}

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getAudienceApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`/beki/targeting`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

// getPreviewListApi
export const getPreviewListApi = async ({ tenantId, authToken, userId, mandateId, campaignIds }) => {
  try {

    const { data } = await client().post("/beki/v2/campaign?list=preview", {
      mandateId,
      campaignIds
    }, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};



export const getThirdPartyAccountApi = async ({ tenantId, authToken, userId }) => {
  try {

    const { data } = await client().get("/beki/account?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const pageListApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}/targeting/fb?get=pages`, payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postAddNewStrategyApi = async ({ tenantId, authToken, userId, alreadyMadeStrategy }) => {
  try {
    const { data } = await client().post("/beki/campaign?strategy=auto&isNew=1", alreadyMadeStrategy, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "length": 0,
    //   "responseObj": {
    //     "msg": "Campaign Basic Details has been successfully updated",
    //     "status": "Success",
    //     "code": 100
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const postFinalStrategyApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post("/beki/campaign?strategy=auto", payload, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "length": 0,
    //   "responseObj": {
    //     "msg": "Campaign Basic Details has been successfully updated",
    //     "status": "Success",
    //     "code": 100
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postValidateStrategyApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}/v2/campaign`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postCampaignNameListApi = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}/platform/campaignname/list`, payload, {
      // params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const dataConfigV2Api = async ({ tenantId, authToken, userId, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}/dataconfigv2/variable?list=all`, payload, {
      // params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getValidateStrategyApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`${endPoints.beki}/publish`, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getRecoApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get(`/beki/targeting`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};






//--------------HOMESCREEN API START HERE----------------

export const getHomeRecentActivityApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(`${endPoints.beki}/home/activity`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "Recent Acitivty Fetched",
    //     "status": "Success",
    //     "code": 12000
    //   },
    //   "response": [
    //     {
    //       "id": 1,
    //       "tenantId": 260,
    //       "mandateId": 0,
    //       "data": {
    //         "isComplete": 1,
    //         "totalBudget": "1111",
    //         "campaignName": "13pop912",
    //         "brandName": "brsjbds",
    //         "goal": "1154",
    //         "goalValue": "1111",
    //         "startDate": "2024-02-13",
    //         "endDate": "2024-02-16",
    //         "businessType": "1178",
    //         "brandUrl": "https://www.google.com",
    //         "category": "299",
    //         "subcategory": "307",
    //         "advId": 260
    //       },
    //       "dataId": 3165,
    //       "desc": "Anchor created new campaign 13pop912",
    //       "cDate": "2024-02-13 14:50:30",
    //       "cUser": 244,
    //       "mUser": 0
    //     },
    //     {
    //       "id": 2,
    //       "tenantId": 260,
    //       "mandateId": 0,
    //       "data": {
    //         "id": 711,
    //         "isComplete": 1,
    //         "totalBudget": "1111",
    //         "campaignName": "13pop912",
    //         "brandName": "brsjbds",
    //         "goal": "1154",
    //         "goalValue": "1111",
    //         "startDate": "2024-02-13",
    //         "endDate": "2024-02-16",
    //         "businessType": "1178",
    //         "brandUrl": "https://www.google.com",
    //         "category": "299",
    //         "subcategory": "307",
    //         "advId": 260
    //       },
    //       "dataId": 3165,
    //       "desc": "Anchor created new campaign 13pop912",
    //       "cDate": "2024-02-13 14:51:51",
    //       "cUser": 244,
    //       "mUser": 0
    //     },
    //     {
    //       "id": 3,
    //       "tenantId": 260,
    //       "mandateId": 0,
    //       "data": {
    //         "id": 711,
    //         "isComplete": 1,
    //         "totalBudget": "1111",
    //         "campaignName": "13pop912",
    //         "brandName": "brsjbds",
    //         "goal": "1154",
    //         "goalValue": "1111",
    //         "startDate": "2024-02-13",
    //         "endDate": "2024-02-16",
    //         "businessType": "1178",
    //         "brandUrl": "https://www.google.com",
    //         "category": "299",
    //         "subcategory": "307",
    //         "advId": 260
    //       },
    //       "dataId": 3165,
    //       "desc": "Anchor just edited the 13pop912 campaign",
    //       "cDate": "2024-02-13 14:53:29",
    //       "cUser": 244,
    //       "mUser": 0
    //     }
    //   ],
    //   "length": 0
    // }

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const getHomeNotificationListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(`${endPoints.beki}/home/notification?list=all`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "User Notification Fetched",
    //     "status": "Success",
    //     "code": 12002
    //   },
    //   "response": [
    //     {
    //       "id": 1,
    //       "tenantId": 260,
    //       "userId": 0,
    //       "alert": "Wallet amount low for tenant Anchor",
    //       "level": 0,
    //       "type": 0,
    //       "action": 1,
    //       "actionData": {
    //         "featureId": 1,
    //         "tenantId": 260,
    //         "entityId": 1
    //       }
    //     },
    //     {
    //       "id": 2,
    //       "tenantId": 831,
    //       "userId": 0,
    //       "alert": "Wallet amount low for tenant Account 1",
    //       "level": 0,
    //       "type": 0,
    //       "action": 1,
    //       "actionData": {
    //         "featureId": 2,
    //         "tenantId": 831,
    //         "entityId": 1
    //       }
    //     }
    //   ],
    //   "length": 0
    // }
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const postHomeNotificationUpdateApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // curl --location --request POST 'http://localhost:7018/beki/home/notification?addup=1' 

  try {
    const { data } = await client().post(`${endPoints.beki}/home/notification`, payload, {

      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    //   let data = {
    //     "responseCode": {
    //         "msg": "User Notification Updated",
    //         "status": "Success",
    //         "code": 12006
    //     },
    //     "length": 0
    //  }


    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getHomeRecommendListApi = async ({ tenantId, authToken, userId }) => {
  try {
    const { data } = await client().get(`/bekireco/reco/stats`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "Variable List Fetched Successfully",
    //     "status": "Success",
    //     "code": 201
    //   },
    //   "responseList": [
    //     {
    //       "tenantId": 1,
    //       "tenantName": "Tenant Name",
    //       "totalReco": 12,
    //       "details": [
    //         {
    //           "recoType": 1,
    //           "recoTypeName": "Generative AI",
    //           "recoCount": 2
    //         },
    //         {
    //           "recoType": 2,
    //           "recoTypeName": "Blacklist",
    //           "recoCount": 10
    //         },
    //       ]
    //     },
    //     {
    //       "tenantId": 1,
    //       "tenantName": "Tenant Name",
    //       "totalReco": 12,
    //       "details": [
    //         {
    //           "recoType": 1,
    //           "recoTypeName": "Generative AI",
    //           "recoCount": 2
    //         },
    //         {
    //           "recoType": 2,
    //           "recoTypeName": "Blacklist",
    //           "recoCount": 10
    //         },
    //       ]
    //     },
    //     {
    //       "tenantId": 1,
    //       "tenantName": "Tenant Name",
    //       "totalReco": 12,
    //       "details": [
    //         {
    //           "recoType": 1,
    //           "recoTypeName": "Generative AI",
    //           "recoCount": 2
    //         },
    //         {
    //           "recoType": 2,
    //           "recoTypeName": "Blacklist",
    //           "recoCount": 10
    //         },
    //       ]
    //     },
    //     {
    //       "tenantId": 1,
    //       "tenantName": "Tenant Name",
    //       "totalReco": 12,
    //       "details": [
    //         {
    //           "recoType": 1,
    //           "recoTypeName": "Generative AI",
    //           "recoCount": 2
    //         },
    //         {
    //           "recoType": 2,
    //           "recoTypeName": "Blacklist",
    //           "recoCount": 10
    //         },
    //       ]
    //     }
    //   ]
    // }

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const postHomeAccountPerformanceApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // https://stageatdv4.torcai.com/druid/dashboard/account-performance?list=total
  try {
    const { data } = await client().post(`${endPoints.atdDashboard}/account-performance`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    //   let data = {
    //     "responseCode": {
    //         "msg": "List Fetched Successfully",
    //         "status": "Success",
    //         "code": 4002
    //     },
    //     "responseList": [
    //         {
    //             "tenantName": "connections",
    //             "tenantType": "Advertiser",
    //             "tenantTypeId": "5",
    //             "tenantId": 1337,
    //             "impressions": 0,
    //             "clicks": 0,
    //             "conversions": 0,
    //             "spend": 0.0,
    //             "cr": 0.0,
    //             "ctr": 0.0,
    //             "ecpm": 0.0,
    //             "cpa": 0.0,
    //             "cpc": 0.0
    //         },
    //         {
    //             "tenantName": "connections2",
    //             "tenantType": "Advertiser",
    //             "tenantTypeId": "5",
    //             "tenantId": 1338,
    //             "impressions": 0,
    //             "clicks": 0,
    //             "conversions": 0,
    //             "spend": 0.0,
    //             "cr": 0.0,
    //             "ctr": 0.0,
    //             "ecpm": 0.0,
    //             "cpa": 0.0,
    //             "cpc": 0.0
    //         },
    //         {
    //             "tenantName": "cacca",
    //             "tenantType": "Advertiser",
    //             "tenantTypeId": "5",
    //             "tenantId": 1340,
    //             "impressions": 0,
    //             "clicks": 0,
    //             "conversions": 0,
    //             "spend": 0.0,
    //             "cr": 0.0,
    //             "ctr": 0.0,
    //             "ecpm": 0.0,
    //             "cpa": 0.0,
    //             "cpc": 0.0
    //         }
    //     ],
    //     "length": 3
    //  }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postHomeCampaignPerformanceApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // curl 'https://stagemoutcome.torcai.com/druid/dashboard/top-Campaign?list=total' 

  try {
    const { data } = await client().post(`${endPoints.atdDashboard}/top-Campaign`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postCampaignAvailableDashboadData = async ({ tenantId, authToken, userId, params, payload }) => {

  try {
    const { data } = await client().post(`${endPoints.atdDashboard}/campaign-data/flag`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const getHomeAdvertiserListApi = async ({ tenantId, authToken, userId }) => {
  // curl --location --request GET 'http://localhost:7018/beki/home/reports/advertiser?list=all' \

  try {
    const { data } = await client().get(`${endPoints.beki}/home/reports/advertiser?list=all`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "Advertiser View Data Fetched",
    //     "status": "Success",
    //     "code": 12013
    //   },
    //   "response": [
    //     {
    //       "advertiserId": 1,
    //       "activeCampaignCount": 1,
    //       "currencyId": 70
    //     },
    //     {
    //       "advertiserId": 317,
    //       "currencyId": 71
    //     },
    //     {
    //       "advertiserId": 345,
    //       "currencyId": 70
    //     },
    //     {
    //       "advertiserId": 349,
    //       "currencyId": 71
    //     },
    //     {
    //       "advertiserId": 359,
    //       "currencyId": 70
    //     },
    //     {
    //       "advertiserId": 381,
    //       "currencyId": 71
    //     }
    //   ],
    //   "length": 0
    // }


    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getHomeDraftCampaignListApi = async ({ tenantId, authToken, userId }) => {
  // curl --location --request GET 'http://localhost:7018/beki/home/campaign?list=all' \

  try {
    const { data } = await client().get(`${endPoints.beki}/home/campaign?list=all`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "Draft Campaigns Fetched Successfully",
    //     "status": "Success",
    //     "code": 11000
    //   },
    //   "response": [
    //     {
    //       "completionPercent": 87,
    //       "isComplete": 0,
    //       "totalBudget": 1111,
    //       "campaignId": 711,
    //       "campaignName": "13pop912",
    //       "goal": 1154,
    //       "goalValue": 1111,
    //       "startDate": "2024-02-13 00:00:00",
    //       "endDate": "2024-02-16 00:00:00",
    //       "businessType": 1178,
    //       "brandName": "brsjbds",
    //       "brandUrl": "https://www.google.com",
    //       "category": 299,
    //       "subcategory": 307,
    //       "advId": 831,
    //       "id": 711,
    //       "isRecActive": 2,
    //       "cDate": "2024-02-13 14:50:30",
    //       "cUser": 0,
    //       "mDate": "2024-02-13 14:53:29",
    //       "mUser": 0,
    //       "tenantType":0
    //     },
    //     {
    //       "completionPercent": 50,
    //       "isComplete": 0,
    //       "totalBudget": 1111,
    //       "campaignId": 711,
    //       "campaignName": "pop1234",
    //       "goal": 1154,
    //       "goalValue": 1111,
    //       "startDate": "2024-02-13 00:00:00",
    //       "endDate": "2024-02-16 00:00:00",
    //       "businessType": 1178,
    //       "brandName": "brsjbds",
    //       "brandUrl": "https://www.google.com",
    //       "category": 299,
    //       "subcategory": 307,
    //       "advId": 260,
    //       "id": 711,
    //       "isRecActive": 2,
    //       "cDate": "2024-02-13 14:50:30",
    //       "cUser": 0,
    //       "mDate": "2024-02-13 14:53:29",
    //       "mUser": 0,
    //       "tenantType":1
    //     }
    //   ],
    //   "length": 0
    // }
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const getPreferenceListAllApi = async ({ tenantId, authToken, userId }) => {
  // curl --location --request GET 'http://localhost:7018/beki/home/preferences?list=all' 

  try {
    const { data } = await client().get(`${endPoints.beki}/home/preferences?list=all`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "User View Preferences Fetched",
    //     "status": "Success",
    //     "code": 12008
    //   },
    //   "response": [
    //     {
    //       // "id": 1,
    //       "cardId": 2977,
    //       "seq": 4,
    //       "cardProperties": "collapsed",
    //       "isActive":0
    //     },
    //     {
    //       // "id": 2,
    //       "cardId": 2978,
    //       "defaultPage": 10,
    //       "seq": 2,
    //       "cardProperties": "collapsed",
    //       "isActive":1
    //     },
    //     {
    //       // "id": 3,
    //       "cardId": 2979,
    //       "defaultPage": 10,
    //       "seq": 1,
    //       "cardProperties": "collapsed",
    //       "isActive":1
    //     },
    //     {
    //       // "id": 4,
    //       "cardId": 2980,
    //       "defaultPage": 10,
    //       "seq": 3,
    //       "cardProperties": "collapsed",
    //       "isActive":1
    //     }
    //   ],
    //   "length": 0
    // }
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};



export const postHomePreferenceApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // curl --location --request POST 'http://localhost:7018/beki/home/preferences?addup=auto'

  try {
    const { data } = await client().post(`${endPoints.beki}/home/preferences`, payload, {

      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "User Preferences Created",
    //     "status": "Success",
    //     "code": 12011
    //   },
    //   "length": 0
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getFeatureModuleListApi = async ({
  tenantId,
  authToken,
  userId,
  params
}) => {
  try {
    const { data } = await client({ auth: true }).get(
      endPoints.auth + `/feature?action=list`,
      {
        params,
        headers: {
          common: {
            torc_tenant: parseInt(tenantId),
            torc_user: userId,
            Authorization: `Bearer ${authToken}`,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};


export const getHomePageListApi = async ({ tenantId, authToken, userId }) => {
  // curl --location --request GET 'http://localhost:7018/beki/home/page?list=all' \

  try {
    const { data } = await client().get(`${endPoints.beki}/home/page?list=all`, {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });

    //   let data = {
    //     "responseCode": {
    //         "msg": "User Default Pages Fetched",
    //         "status": "Success",
    //         "code": 12018
    //     },
    //     "response": [
    //         {
    //             "userId": 244,
    //             "tenantId": 772,
    //             "defaultPage": 0
    //         },
    //         {
    //             "userId": 244,
    //             "tenantId": 1610,
    //             "defaultPage": 2  
    //         },
    //         {
    //             "userId": 244,
    //             "tenantId": 260,
    //             "defaultPage": 173
    //         },
    //         {
    //             "userId": 244,
    //             "tenantId": 532,
    //             "defaultPage": 226
    //         },
    //         {
    //             "userId": 244,
    //             "tenantId": 617,
    //             "defaultPage": 235
    //         }
    //     ],
    //     "length": 0
    // }

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const postHomeDefaultPageApi = async ({ tenantId, authToken, userId, params, payload }) => {
  // curl --location --request POST 'http://localhost:7018/beki/home/page?addup' 

  try {
    const { data } = await client().post(`${endPoints.beki}/home/page`, payload, {

      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

//----------------HOMESCREEN API ENDS HERE------------------------


// -----------------NEW OPTIMIZER API---------------------

export const getNewOptimizerListApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    const { data } = await client().get("bekireco/reco/list", {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    // let data = {
    //   "responseCode": {
    //     "msg": "Recommendation List Fetched Successfully",
    //     "status": "Success",
    //     "code": 201
    //   },
    //   "responseList":
    //   {
    //     "generativeAI": {
    //       "totalCampaign": 10,
    //       "id": 1,
    //       "type": [
    //         {
    //           "key": "keywords",
    //           "value": 5,
    //           "id": 1
    //         },
    //         {
    //           "key": "creatives",
    //           "value": 5,
    //           "id": 2
    //         }
    //       ]
    //     },
    //     "blacklisting": {
    //       "totalCampaign": 10,
    //       "id": 2,
    //       "type": [
    //         {
    //           "key": "domain",
    //           "value": 7,
    //           "id": 4
    //         },
    //         {
    //           "key": "age",
    //           "value": 2,
    //           "id": 5
    //         },
    //         {
    //           "key": "gender",
    //           "value": 1,
    //           "id": 6
    //         },
    //         {
    //           "key": "geo",
    //           "value": 3,
    //           "id": 7
    //         },
    //         {
    //           "key": "placement",
    //           "value": 1,
    //           "id": 8
    //         },
    //         {
    //           "key": "device",
    //           "value": 1,
    //           "id": 9
    //         }
    //       ]
    //     },
    //     "optimiser": {
    //       "totalCampaign": 10,
    //       "id": 3,
    //       "type": [
    //         {
    //           "key": "budgetAllocation",
    //           "value": 5,
    //           "id": 10
    //         },
    //         {
    //           "key": "targetcpm",
    //           "value": 7,
    //           "id": 11
    //         },
    //         {
    //           "key": "targetcpc",
    //           "value": 5,
    //           "id": 12
    //         },
    //         {
    //           "key": "targetcpa",
    //           "value": 2,
    //           "id": 13
    //         }
    //       ]
    //     },
    //     "bidControl": {
    //       "totalCampaign": 10,
    //       "id": 4,
    //       "type": [
    //         {
    //           "key": "age",
    //           "value": 5,
    //           "id": 14
    //         },
    //         {
    //           "key": "gender",
    //           "value": 7,
    //           "id": 15
    //         },
    //         {
    //           "key": "device",
    //           "value": 1,
    //           "id": 16
    //         },
    //         {
    //           "key": "creatives",
    //           "value": 7,
    //           "id": 18
    //         },
    //         {
    //           "key": "geo",
    //           "value": 7,
    //           "id": 18
    //         },
    //         {
    //           "key": "audience",
    //           "value": 7,
    //           "id": 18
    //         }
    //       ]
    //     }
    //   }
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const updateStatusAcceptRejectOptimizerApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    // 1./reco/update?id=1&type=3

    const { data } = await client().get(`bekireco/reco/update`, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "Recommendation updated Successfully",
    //     "status": "Success",
    //     "code": 201
    //   }
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getRecoTypeSubTypeApi = async ({ tenantId, authToken, userId, payload, params }) => {
  try {
    // /reco/details {"type":1,"subType":[2,3,4]}

    const { data } = await client().post(`bekireco/reco/details`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "msg": "Recommendation List Fetched Successfully",
    //     "status": "Success",
    //     "code": 201
    //   },
    //   "responseList":
    //   {
    //     "generativeai": {
    //       "creatives": [
    //         {
    //           "id": 1,
    //           "date": "2024-01-04",
    //           "campaignId": 5,
    //           "campaignName": "Spring Collection Launch",
    //           "startegyId": 11,
    //           "platformName": "Adwords",
    //           "recommendation": "Compelling_Creatives, Captivating_Creatives",
    //         },
    //         {
    //           "id": 2,
    //           "date": "2024-01-05",
    //           "campaignId": 6,
    //           "campaignName": "Year-End Promotion",
    //           "startegyId": 12,
    //           "platformName": "Meta",
    //           "recommendation": "Innovative_Creatives, Persuasive_Creatives",
    //         },
    //         {
    //           "id": 3,
    //           "date": "2024-01-06",
    //           "campaignId": 7,
    //           "campaignName": "Summer Outdoor Adventure",
    //           "startegyId": 13,
    //           "platformName": "Adwords",
    //           "recommendation": "Engaging_Creatives, Impactful_Creatives",
    //         },
    //         {
    //           "id": 4,
    //           "date": "2024-01-07",
    //           "campaignId": 8,
    //           "campaignName": "Back to School Campaign",
    //           "startegyId": 14,
    //           "platformName": "Meta",
    //           "recommendation": "Compelling_Creatives, Persuasive_Creatives",
    //         },
    //         {
    //           "id": 5,
    //           "date": "2024-01-08",
    //           "campaignId": 9,
    //           "campaignName": "Winter Holiday Festivities",
    //           "startegyId": 15,
    //           "platformName": "Adwords",
    //           "recommendation": "Impactful_Creatives, Captivating_Creatives",
    //         },
    //         {
    //           "id": 6,
    //           "date": "2024-01-09",
    //           "campaignId": 10,
    //           "campaignName": "Product Launch Campaign",
    //           "startegyId": 16,
    //           "platformName": "Adwords",
    //           "recommendation": "Relevant_Creatives, Targeted_Creatives",
    //         },
    //         {
    //           "id": 7,
    //           "date": "2024-01-10",
    //           "campaignId": 11,
    //           "campaignName": "Summer Sale Campaign",
    //           "startegyId": 18,
    //           "platformName": "Meta",
    //           "recommendation": "Effective_Creatives, Engaging_Creatives",
    //         },
    //       ],
    //       "keywords": [
    //         {
    //           "id": 1,
    //           "date": "2024-01-04",
    //           "campaignId": 5,
    //           "campaignName": "Product Launch Campaign",
    //           "startegyId": 11,
    //           "platformName": "Adwords",
    //           "recommendation": "Relevant_Keywords, Targeted_Keywords",
    //         },
    //         {
    //           "id": 2,
    //           "date": "2024-01-05",
    //           "campaignId": 6,
    //           "campaignName": "Summer Sale Campaign",
    //           "startegyId": 12,
    //           "platformName": "Meta",
    //           "recommendation": "Effective_Keywords, Engaging_Keywords",
    //         },
    //         {
    //           "id": 3,
    //           "date": "2024-01-06",
    //           "campaignId": 7,
    //           "campaignName": "Holiday Season Campaign",
    //           "startegyId": 13,
    //           "platformName": "Adwords",
    //           "recommendation": "Impactful_Keywords, Compelling_Keywords",
    //         },
    //         {
    //           "id": 4,
    //           "date": "2024-01-07",
    //           "campaignId": 8,
    //           "campaignName": "Year-End Clearance Campaign",
    //           "startegyId": 14,
    //           "platformName": "Meta",
    //           "recommendation": "Relevant_Keywords, Persuasive_Keywords",
    //         },
    //         {
    //           "id": 5,
    //           "date": "2024-01-08",
    //           "campaignId": 9,
    //           "campaignName": "New Product Showcase Campaign",
    //           "startegyId": 15,
    //           "platformName": "Adwords",
    //           "recommendation": "Engaging_Keywords, Compelling_Keywords",
    //         }
    //       ]
    //     }
    //   }
    // }
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const thirdPartyExecuteApi = async ({ tenantId, authToken, userId, payload, params }) => {
  try {
    const { data } = await client().post(`beki/reco/executeReco`, payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    // let data = {"responseCode":{"msg":"Recommandation Executed Under Process","status":"Success","code":21009},"length":0}

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

// -----------------NEW OPTIMIZER API---------------------



//-----------------HEADER-USER-PROFILE---------------------

export const getUserProfileDetailsApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    // (Domain name)/auth/v3/user?getProfile={userId}'

    const { data } = await client().get(endPoints.auth + `/user`, {
      params,
      headers: {
        common: {
          'torc_tenant': parseInt(tenantId),
          'torc_user': userId,
          'Authorization': `Bearer ${authToken}`
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "code": 8016,
    //     "status": "Success",
    //     "msg": "User Profile Details Fetched Successfully"
    //   },
    //   "responseList": [
    //     {
    //       "userId": "1",
    //       "email": "abc@infomo.com",
    //       "name": "abc",
    //     }
    //   ]
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}


export const postUserProfileDetailsApi = async ({ tenantId, authToken, userId, payload, params }) => {
  try {
    // /reco/details {"type":1,"subType":[2,3,4]}

    const { data } = await client().post(endPoints.auth + `/user`, payload, {
      params,
      headers: {
        common: {
          'torc_tenant': parseInt(tenantId),
          'torc_user': userId,
          'Authorization': `Bearer ${authToken}`
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "code": 17011,
    //     "status": "Success",
    //     "msg": "User Updated Successfully"
    //   }
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const getTenantAccountAccessApi = async ({ tenantId, authToken, userId, params }) => {
  try {
    // '(Domain name)/auth/v3/tenant?tenantHierarchy={userId}'

    const { data } = await client().get(endPoints.auth + `/tenant`, {
      params,
      headers: {
        common: {
          'torc_tenant': parseInt(tenantId),
          'torc_user': userId,
          'Authorization': `Bearer ${authToken}`
        }
      }
    }
    );
    // let data = {
    //   "responseCode": {
    //     "code": 17013,
    //     "status": "Success",
    //     "msg": "Tenant Hierarchy Fetched Successfully"
    //   },
    //   "responseList": [
    //     {
    //       "tenantName": "abc",
    //       "tenantId": 1,
    //       "roleName": "role",
    //       "parentName": "user",
    //       "isParent": true,
    //       "level": 1
    //     },
    //     {
    //       "tenantName": "def",
    //       "tenantId": 2,
    //       "roleName": "role",
    //       "parentName": "user",
    //       "isParent": true,
    //       "level": 1
    //     },
    //     {
    //       "tenantName": "ghi",
    //       "tenantId": 3,
    //       "roleName": "role",
    //       "parentName": "abc",
    //       "parentId": 1,
    //       "isParent": false,
    //       "level": 2
    //     },
    //     {
    //       "tenantName": "jkl",
    //       "tenantId": 4,
    //       "roleName": "role",
    //       "parentName": "abc",
    //       "parentId": 1,
    //       "isParent": false,
    //       "level": 2
    //     },
    //     {
    //       "tenantName": "mno",
    //       "tenantId": 5,
    //       "roleName": "role",
    //       "parentName": "def",
    //       "parentId": 2,
    //       "isParent": false,
    //       "level": 2
    //     }
    //   ]
    // }

    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

//-----------------HEADER-USER-PROFILE---------------------


export const getDefaultPageAccessApi = async ({ tenantId, authToken, userId }) => {
  try {
    // curl 'https://devoutcome.torcai.com/beki/home/page?list=defaultPage'
    const { data } = await client().get(endPoints.beki + "/home/page?list=defaultPage",
      {
        headers: {
          common: {
            'tai_tenant': parseInt(tenantId),
            'tai_token': authToken,
            'tai_user': userId,
          },
        },
      }
    );
    // let data = {"responseCode":{"msg":"User Tenant Default Page Fetched","status":"Success","code":12019},"length":0,"responseObj":{"defaultPage":253}}
    return data;
  } catch (error) {
    throw error;
  }
};